// InstagramCreatePost.js
import React from "react";
import http from '../modules/api';

import TextInput from "../modules/common/TextInput";
import SelectBoxV2 from '../modules/common/SelectBoxV2';
import SaveDialogV2 from '../modules/dialogs/SaveDialogV2';
import BasicDialogV2 from "../modules/dialogs/BasicDialogV2";
import WarningDialog from "../modules/dialogs/WarningDialog";
import ConfirmDialogV2 from '../modules/dialogs/ConfirmDialogV2';
import RoboImgSettingPopup from '../autoEvent/component/RoboImgSettingPopup';
import RoboImageStudioTabs from "../autoEvent/component/RoboImageStudioTabs";
import SearchProductPopup from '../modules/popup/SearchProductPopup';
import PopupFrameV2 from '../modules/popup/PopupFrameV2';
import CheckBox from "../modules/common/CheckBox";
import InstagramTemplateEditor from "./InstagramTemplateEditor";
import ModalSizeSelect from "./component/ModalSizeSelect"; 
import data from '@emoji-mart/data'
import Picker from '@emoji-mart/react'

import * as StringUtil from '../modules/utils/StringUtil';

import DatePicker from "react-datepicker";
import { ko } from "date-fns/locale";
import { format } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";

import {
    DndContext,
    closestCenter,
    PointerSensor,
    useSensor,
    useSensors
  } from "@dnd-kit/core";
import {
    arrayMove as arraymMoveByDndKit,
    SortableContext,
    useSortable,
    rectSortingStrategy
  } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { current } from "@reduxjs/toolkit";

const sensors = [
    {
      sensor: PointerSensor,
      options: {
        activationConstraint: {
          delay: 0,
          tolerance: 5,
        },
      },
    },
];

const _ = require('lodash');

const FACEBOOK_APP_ID = '780456611206591';
const BASEDOMAIN = document.domain.indexOf("127.0.0.1") >= 0 ? 'https://127.0.0.1:8092' : "https://robomd.io";
const REDIRECT_URI = BASEDOMAIN + '/rest/shop/instagram/callbackForRefleshParent';
const SCOPES = [
    'pages_show_list',
    // 'pages_read_engagement',
    'business_management',
    'instagram_basic',
    'instagram_content_publish',
    'instagram_manage_insights',
    // 'catalog_management',
    // 'instagram_shopping_tag_products',
    'public_profile'
].join(',');

// function isShown(el) {
//     if (!el) return false;
//     const cs = getComputedStyle(el);
//     return cs.display !== 'none' && cs.visibility !== 'hidden' && cs.opacity !== '0';
// }
// function updatePadding() {
//     const menu = document.querySelector(".pc_left_menu");
//     const header = document.querySelector(".pc_header");
//     const content = document.getElementById("imageSourceModal");
    
//     if (!content) return; // content 없으면 패스

//     const left = isShown(menu)   ? menu.getBoundingClientRect().width  : 0;
//     const top  = isShown(header) ? header.getBoundingClientRect().height: 0;

//     content.style.paddingLeft = left + "px";
//     content.style.paddingTop  = top + "px";

//     // console.log(left, top);
// }

// // 리사이즈 때마다 실행
//  window.addEventListener("resize", updatePadding);

// 1) 개별 태그: useSortable 적용
function SortableTag({ id, onRemove, children }) {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });

  const style = {
    transform: transform
      ? `translate3d(${transform.x}px, ${transform.y}px, 0)`
      : undefined,
    transition,
  };

  return (
    <span
      ref={setNodeRef}
      className="tag"
      style={{
        ...style,
        display: "inline-flex",
        alignItems: "center",
        padding: "4px 10px",
        background: "rgba(0,226,230,.1)",
        border: "1px solid #00e2e6",
        borderRadius: 16,
        fontSize: 14,
        marginRight: 8,
        marginBottom: 8,
        cursor: "move",
      }}
      {...attributes}
      {...listeners}
    >
      {children}
      <span
        className="tag-remove"
        onClick={onRemove}
        onPointerDown={(e) => e.stopPropagation()}
        style={{
          marginLeft: 6,
          cursor: "pointer",
          color: "#8e8e8e",
          fontSize: 16,
          lineHeight: 1,
        }}
        title="삭제"
      >
        ×
      </span>
    </span>
  );
}

export default class InstagramCreatePost extends React.Component {
  constructor(props) {
    super(props);
    this.captionTextareaRef = React.createRef();
    this.isComposing = false;
    this.state = {
      // 사이즈 선택 여부
      isSizeModalOpen: false,

      add_account_list: [],
      selected_account_list : [],

      // 진행 단계
      currentStep: 1, // 1,2,3
      // 계정
      accountConnected: false,
      selectedAccount: {},
      // 피드 유형
      selectedFeedType: "SINGLE", // 'SINGLE' | 'CAROUSEL' | 'REELS'
      // 이미지 슬롯 (최대 10)
      imageSlots: [{ type: null, data: null }], // [{type:'upload'|'product'|'ai'|'template', data: string|null}]
      // 모달
      imageModalOpen: false,
      currentImageSlotIndex: 0,
      // 문구/해시태그
      caption_history: [],
      caption_future: [],
      caption: "",
      topicInput: "",
      aiSuggestionsVisible: false,
      inputHashtagValue: "",
      tags: ["#신상품", "#데일리룩"],
      // 발행 설정
      previewSlideIndex: 0,
      publishOption: "NOW", // 'now' | 'scheduled'
      scheduledDate: "",
      scheduledTime: "00:00",

      /** 로딩 다이얼로그 */
      save_dialog_show_state: false,
      save_dialog_content: "로딩중 입니다.",
      save_dialog_button_list: [
          {
              title: "확인",
              type: "1",
              display_yn:"N",
          }
      ],

      /** 확인,취소 다이얼로그 */
      confirm_dialog_show_state : false,
      confirm_dialog_content : "",
      confirm_dialog_button_list : [],

      /* BasicDialog 변수 */
      basic_dialog_show_state: false,
      basic_dialog_content: "",
      basic_dialog_button_list: [{title:"확인", event_method:()=>{this.setState({basic_dialog_show_state:false})}}],

      /* 경고 다이얼로그 */
      warning_dialog_show_state: false,
      warning_dialog_content: "",
      warning_dialog_button_list: [{title:"확인", event_method:()=>{this.setState({warning_dialog_show_state:false})}}],

      emojiPickerVisible: false,

      selected_event_seq: "",
    };

    // 파일 입력 ref (업로드용)
    this.fileInputRef = React.createRef();
  }

  componentDidMount() { 
    this.instagramFreePreriod();

    const mediaId = StringUtil.getUrlParams('media_id');
    this.setState({ media_id: mediaId });

    this.loadInstagramAccountList ();
    window.addEventListener('message', (e) => {
      // 보안: 허용된 origin만 처리
      // console.log("### e.data", e.data);
      if (e.data && e.data.type == 'refreshInstagramAccount') {
        if (e.data.token_id) {
          // alert("token_id : " + this.state.token_id);
          this.loadInstagramAccountList(e.data.token_id);
          this.setState({
            token_id: e.data.token_id,
            show_account_connect_popup: true
          })
        }

        // this.loadInstagramAccountList();
        return;
      }
    });

    const { scheduledDate, scheduledTime } = this.state;
    if (scheduledDate && scheduledTime) {
      // 기존 값으로 Date 객체 초기화
      const init = new Date(`${scheduledDate}T${scheduledTime}:00`);
      this.setState({ scheduledAt: init });
    }

    if (mediaId) {
      this.loadInstagramMediaDetail(mediaId);
    }
  }
  

componentDidUpdate(prevProps, prevState) {
  const prevCnt = (prevState.imageSlots || []).filter(s => s && s.type && s.data).length;
  const currCnt = (this.state.imageSlots || []).filter(s => s && s.type && s.data).length;
  if (prevCnt !== currCnt) {
    const total = currCnt || 1;
    const idx = this.state.previewSlideIndex || 0;
    const fixed = ((idx % total) + total) % total;
    if (fixed !== idx) {
      this.setState({ previewSlideIndex: fixed });
    }
  }

  if(this.state.show_add_product_popup) {
      document.body.style.overflow = 'hidden'; // 스크롤 고정
  } else {
      document.body.style.overflow = 'auto'; // 스크롤 고정 해제
  }
}

  loadInstagramAccountList (token_id) {
    if (token_id) {
          http.get("/rest/shop/instagram/profile/list?token_id=" + token_id)
            .then(res => {
              if (res.data.list != null) {
                this.setState({
                  add_account_list: res.data.list,
                });
              }
            }).catch(error => {
              console.log(error);
            })
        }
    else {
      http.get("/rest/shop/instagram/profile/list")
      .then(res => {
          if (res.data.list != null) {
              // console.log("res.data.list.length", res.data.list.length)
              // res.data.list가 없을 수도 있으니 안전하게 처리
              const list = Array.isArray(res?.data?.list) ? res.data.list : [];

              const account_list      = this.buildIgAccountOptions(list);
              const account_list_v2   = this.buildIgAccountOptionsV2(list);
              const defaultSeq        = this.buildIgDefaultAccount(list) || "";
              const key               = String(this.state.selected_ig_access_seq || defaultSeq || "");

              // acc.value 타입이 섞여 있을 수 있으니 문자열로 맞춰 비교
              const targetAcc = (account_list_v2 || []).find(acc => String(acc.value) === key) || null;

              this.setState({
                account_list,
                account_list_v2,
                default_ig_access_seq: defaultSeq,
                accountConnected: list.length > 0,
                selectedAccount: targetAcc || null,
              }, () => {
                // console.log(
                //   "account_list_v2.length:",
                //   this.state.account_list_v2?.length || 0,
                //   "default_ig_access_seq:",
                //   this.state.default_ig_access_seq
                // );
              });
          }
        }).catch(error => {
          console.log (error);
        })
    }
  }

  loadInstagramMediaDetail = async (mediaId, blocked_load_dialog = false) => {
    if (!mediaId) return;
    try {
      if (blocked_load_dialog !== true) {
        this.setState({ save_dialog_show_state: true, save_dialog_content: "게시물 불러오는 중..." });
      }

      const { data: res } = await http.get(`/rest/shop/instagram/media/${mediaId}`);
      const r = res || {};

      if (r.status == "PUBLISHED") {
        alert("이미 발행된 게시물은 수정할 수 없습니다.");
        window.location.href = '/shop/instagram/InstagramPostList';
      }

      // items -> imageSlots 매핑
      const items = Array.isArray(r.items) ? r.items : [];
      const imageSlots = items.map((it) => {
        const src = it.source || {};
        // 서버 source_type_cd -> 클라이언트 type 매핑
        const type =
          src.source_type_cd === "U" ? "upload" :
          src.source_type_cd === "P" ? "product" :
          src.source_type_cd === "A" ? "ai" :
          src.source_type_cd === "T" ? "template" :
          // 안전망: product_no 있으면 product, 아니면 upload로
          (src.product_no ? "product" : "upload");

        return {
          type,
          data: src.source_url || it.preview_image_url || null,
          media_source_id: it.media_source_id || src.media_source_id || null,
          product_no: src.product_no || it.product_no || null,
          stability_call_seq: it.stability_call_seq || null,
          event_seq: src.event_seq || null,
          product_name: src.product_name || null,
        };
      });

      // 최소 1칸은 유지
      const normalizedSlots = imageSlots.length ? imageSlots : [{ type: null, data: null }];

      // 해시태그 문자열 → 배열
      const tags = Array.isArray(r.hashtags)
        ? r.hashtags
        : (typeof r.hashtags === "string" ? r.hashtags.split(/\s+/).filter(Boolean) : []);

      // 예약 시간 파싱 (YYYY-MM-DD HH:mm:ss 또는 ISO)
      const scheduledRaw = r.scheduled_time || r.scheduled_at || "";
      let scheduledDate = "";
      let scheduledTime = "";
      if (scheduledRaw) {
        const iso = scheduledRaw.replace(" ", "T");
        const d = new Date(iso);
        // 문자열이 확실하다면 슬라이스 방식으로 더 단순히:
        const s = scheduledRaw.replace("T", " "); // "YYYY-MM-DD HH:mm:ss"
        scheduledDate = s.slice(0, 10);
        scheduledTime = s.slice(11, 16);
        // d 변환 실패 케이스도 위 슬라이스가 안전망 역할
      }

      // 피드 타입은 이미지 개수로 추정
      const selectedFeedType = (r.media_type_cd === "C") ? "CAROUSEL" : "SINGLE";

      // 게시 방식
      // const publishOption =
      //   (r.post_type === "SCHEDULED" || scheduledRaw) ? "SCHEDULED" : "NOW";

      this.setState({
        media_id: r.instagram_media_seq || mediaId,
        selected_ig_access_seq: r.instagram_access_token_seq ? String(r.instagram_access_token_seq) : this.state.selected_ig_access_seq,
        imageSlots: normalizedSlots,
        // caption: r.caption || "",
        tags,
        publishOption : r.post_type,
        scheduledDate,
        scheduledTime,
        // 참고 값들(필요시 UI에 사용)
        is_draft: r.is_draft,
        status: r.status,
        selectedFeedType,
        previewSlideIndex: 0,

        // AI 문구 도우미 
        aiSuggestionsVisible:r.gpt_caption_suggestions && JSON.parse(r.gpt_caption_suggestions).length > 0 ? true : false,
        topicInput: r.caption_prompt || "",
        aiRecommendations: r.gpt_caption_suggestions ? JSON.parse(r.gpt_caption_suggestions) : [],
        selectedLabel: r.gpt_caption_selected_suggestions || "",
        currentRatio: r.image_ratio || "1/1",
      }, () => {  
        // console.log("r.gpt_caption_suggestions", r.gpt_caption_suggestions);
        // console.log("r.gpt_caption_suggestions.length", JSON.parse(r.gpt_caption_suggestions).length);
        // console.log("aiSuggestionsVisible", this.state.aiSuggestionsVisible);
      });
      this.setCaption(r.caption || "");
      
    } catch (err) {
      console.error(err);
      this.setState({
        basic_dialog_show_state: true,
        basic_dialog_content: "게시물 불러오기에 실패했습니다.",
      });
    } finally {
      this.setState({ save_dialog_show_state: false });
    }
  }

  buildIgAccountOptions(apiPayload) {
    const src = apiPayload && (apiPayload.list || apiPayload) || [];
    const opts = [];

    src.forEach(fb => {
      const fbName = fb.facebook_username || "(이름 없음)";
      const igList = fb.instagram_account_list || [];
      igList.forEach(ig => {
        const v = String(ig.instagram_access_token_seq ?? "");
        if (!v) return; // 식별자 없으면 스킵
        const uname = ig.username ? `@${ig.username}` : "(계정명 없음)";
        opts.push({
          value: v,
          title: `${fbName} / ${uname}`,
        });
      });
    });

    return opts;
  }

  buildIgAccountOptionsV2(apiPayload) {
    const src = apiPayload && (apiPayload.list || apiPayload) || [];
    const opts = [];

    src.forEach(fb => {
      const igList = fb.instagram_account_list || [];
      igList.forEach(ig => {
        const v = String(ig.instagram_access_token_seq ?? "");
        if (!v) return; // 식별자 없으면 스킵
        const uname = ig.username ? `${ig.username}` : "(계정명 없음)";
        opts.push({
          value: v,
          title: `${uname}`,
          profile_picture_url: ig.profile_picture_url || null,
        });
      });
    });

    return opts;
  }

  buildIgDefaultAccount(apiPayload) {
    const src = (apiPayload && (apiPayload.list || apiPayload)) || [];
    
    // 1. 모든 facebook 객체에서 instagram_account_list를 추출하여 하나의 배열로 만듭니다.
    const allIgAccounts = src.reduce((acc, fb) => {
        return acc.concat(fb.instagram_account_list || []);
    }, []);

    if (allIgAccounts.length === 0) return "";

    // 2. 전체 배열에서 default_yn === 'Y'인 것을 찾습니다.
    const defaultAcc = allIgAccounts.find(ig => ig.default_yn === 'Y');

    // 3. 찾았다면 그 시퀀스를 반환, 없다면 배열의 첫 번째 계정을 반환합니다.
    if (defaultAcc) {
        return String(defaultAcc.instagram_access_token_seq ?? "");
    } else {
        return String(allIgAccounts[0].instagram_access_token_seq ?? "");
    }
  }

  // ====== 공통 유틸 ======
  goToStep = (n) => {
    if (n < 1 || n > 3) return;
    this.setState({ currentStep: n });
    window.scrollTo(0, 0);
  };

  onChangeAccount = (text, value) => {
    // console.log("onChangeAccount", text, value);
    const targetAcc = (this.state.account_list_v2 || [])
      .find(acc => acc.value == value);
    this.setState({ 
      selected_ig_access_seq: value,
      selectedAccount: targetAcc || null,
    });
  };

  // ====== 피드 유형 ======
  selectFeedType = (type) => {
    if (type === "SINGLE") {
      // 첫 슬롯만 유지
      this.setState({
        selectedFeedType: "SINGLE",
        imageSlots: [this.state.imageSlots[0] || { type: null, data: null }],
      });
    } else if (type === "REELS") {
      this.setState({ selectedFeedType: "REELS" });
    } else {
      this.setState({ selectedFeedType: "CAROUSEL" });
    }
  };

  // ====== 이미지 슬롯 ======
  addNewImageSlot = () => {
    this.setState((prev) => {
      if (prev.imageSlots.length >= 10) {
        alert("최대 10개까지만 추가할 수 있습니다.");
        return null;
      }
      return { imageSlots: [...prev.imageSlots, { type: null, data: null }] };
    });
  };

  isAllImageSlotsEmpty = () => {
    const { imageSlots } = this.state;

    return (imageSlots || []).every(slot => {
      if (!slot) return true;
      return !(slot.data || slot.preview_image_url);
    });
  };

  openImageModal = (index, slot_type) => {
    if (slot_type === "template") {
      this.setState({ show_design_template_popup: true, selected_event_seq: (this.state.imageSlots[index].event_seq || ""), currentImageSlotIndex: index });
    } else {
      if (this.isAllImageSlotsEmpty()) {
        this.setState({ isSizeModalOpen: true, currentImageSlotIndex: index });
      } else {
        this.setState({ imageModalOpen: true, currentImageSlotIndex: index });
      }
    }
  };

  closeImageModal = () => {
    this.setState({ imageModalOpen: false });
  };

  // 모달 옵션 선택
  handleImageSource = (source, event_seq) => {
    const idx = this.state.currentImageSlotIndex;
    if (source === "upload") {
      // 실제 파일 선택
      if (this.fileInputRef.current) {
        this.fileInputRef.current.onchange = async (e) => {
          const file = e.target.files && e.target.files[0];
          if (!file) return;
          const reader = new FileReader();
          reader.onload = (ev) => {
            // this.setState((prev) => {
            //   const imageSlots = [...prev.imageSlots];
            //   imageSlots[idx] = { type: "upload", data: ev.target.result }; // dataURL
            //   return { imageSlots };
            // }, () => {
            //   console.log("ev.target.result", ev.target.result)
            // });
          };
          // reader.readAsDataURL(file);
          this.saveS3Image(idx, file);
        };
        this.fileInputRef.current.click();


      }
    } else if (source === "product") {
      // 책/상품
      // this.setState((prev) => {
      //   const imageSlots = [...prev.imageSlots];
      //   imageSlots[idx] = { type: source, data: null };
      //   return { imageSlots };
      // });
      this.setState({ show_add_product_popup: true,  }, () => {
        this.closeImageModal();
      });
    } else if (source === "ai") {
      // AI
      // this.setState((prev) => {
      //   const imageSlots = [...prev.imageSlots];
      //   imageSlots[idx] = { type: source, data: null };
      //   return { imageSlots };
      // });
      this.setState({ show_robo_img_popup: true}, () => {
        this.closeImageModal();
      });

    } else if (source === "template") {
      this.setState({ show_design_template_popup: true,  selected_event_seq: "" }, () => {
        this.closeImageModal();
      });
    } else {
      // product/ai/template 는 더미로 유형만 반영
      this.setState((prev) => {
        const imageSlots = [...prev.imageSlots];
        imageSlots[idx] = { type: source, data: null };
        return { imageSlots };
      });
    }
    this.closeImageModal();
  };

  deleteImageAt = (e, index) => {
    e.stopPropagation();
    this.setState((prev) => {
      const imageSlots = [...prev.imageSlots];
      imageSlots[index] = { type: null, data: null };
      return { imageSlots };
    }, () => {
      // state 갱신 후 file input 초기화
      if (this.fileInputRef?.current) {
        this.fileInputRef.current.value = "";
      }
    });
  };

  saveS3Image = (idx, file) => {
    this.setState({ save_dialog_show_state: true });
    const config = {
      headers: {
          'Content-Type': 'multipart/form-data'
      }
    }
    const formData = new FormData();
    formData.append("files", file);
    formData.append("ratio", this.state.currentRatio ? this.state.currentRatio : "1/1");
        
    http.post("/rest/shop/instagram/resizeOrgImg", formData, config)
    .then(res => {
        const url = res.data.org_img_path;
        this.setState((prev) => {           
          const imageSlots = [...prev.imageSlots];
          imageSlots[idx] = { type: "upload", data: url };
          return { imageSlots };
        }, () => {
          // 처리 후에도 file input 초기화
          if (this.fileInputRef?.current) this.fileInputRef.current.value = "";
        });
        this.setState({ save_dialog_show_state: false });
      }).catch(error => {
        console.log (error);
        this.setState({ save_dialog_show_state: false });
      })
  }

  // ====== 문구/해시태그 ======
  onChangeCaption = (e) => this.setCaption(e.target.value); //this.setState({ caption: e.target.value });

  showEmojiPicker = () => {
    // const emojis = ["😊", "❤️", "🎉", "👍", "✨", "🔥", "💕", "🌟", "😍", "🙌"];
    // const random = emojis[Math.floor(Math.random() * emojis.length)];
    // this.setState((prev) => ({ caption: prev.caption + random }));
    this.setState((prev) => ({ emojiPickerVisible: !prev.emojiPickerVisible }));
  };

  // handleEmojiSelect = (emoji) => {
  //   this.setState((prev) => ({ caption: prev.caption + emoji.native }));
  // };

  handleEmojiSelect = (emoji) => {
    // alert(emoji.native);
    const textarea = this.captionTextareaRef.current;
    if (!textarea) return;

    const { selectionStart, selectionEnd } = textarea;
    const before = this.state.caption.slice(0, selectionStart);
    const after = this.state.caption.slice(selectionEnd);

    const newCaption = before + emoji.native + after;

    // this.setState({ caption: newCaption }, () => {
    //   // 커서를 방금 삽입한 이모지 뒤로 이동
    //   const pos = selectionStart + emoji.native.length;
    //   textarea.selectionStart = textarea.selectionEnd = pos;
    //   textarea.focus();
    // });

    this.setCaption(newCaption, () => {
      const pos = selectionStart + emoji.native.length;
      textarea.selectionStart = textarea.selectionEnd = pos;
      textarea.focus();
    });
  };

 // 예비 문구 (AI 응답이 없을 때 대비)
  fallbackMap = {
    신상품:
      "🎉 새로운 시즌을 맞이하는 특별한 아이템이 도착했어요!\n\n트렌디하면서도 실용적인 디자인으로 일상을 더욱 스타일리시하게 만들어 드릴게요. 지금 바로 만나보세요! 💕",
    할인:
      "🔥 지금이 기회! 특별 할인 이벤트가 시작되었습니다!\n\n평소 관심있던 아이템들을 더욱 합리적인 가격으로 만나보세요. 한정 수량이니 서둘러주세요! ⏰",
    브랜드:
      "💭 저희 브랜드의 특별한 이야기를 들려드릴게요\n\n고객 한 분 한 분을 생각하며 정성스럽게 만든 제품들이 여러분의 일상에 작은 행복을 전해드리길 바랍니다. 🌟",
  };

  // 버튼 클릭: 주제 변경 + 해당 text 표시 (API 재호출 없음)
  useSuggestion = (label) => {
    const { aiRecommendations = [] } = this.state;

    // AI 응답에서 label 매칭
    const found = aiRecommendations.find((r) => r.label === label);
    const text =
      found?.text?.trim?.() ||
      this.fallbackMap[label] ||
      "문구를 찾지 못했어요. 다른 라벨을 선택해 보세요.";

    this.setCaption(text);
    this.setState({
      // caption: text,           // 텍스트만 반영
      selectedLabel: label,    // UI 하이라이트용
      aiSuggestionsVisible: true,
    });
  };

  generateAICaption = async () => {
    const { topicInput, imageSlots = [] } = this.state;
    const productNameList = imageSlots
      .filter((s) => s && s.type === "product" && s.product_name)
      .map((s) => s.product_name);

    // 유효성 검사    
    // if (!imageSlots || imageSlots.length === 0) {
    //   alert("최소 한 개 이상의 이미지를 추가해주세요.");
    //   return;
    // }

    if (!topicInput || !topicInput.trim()) {
      alert("주제를 입력해주세요.");
      return;
    }
    // if (!Array.isArray(productNameList) || productNameList.length === 0) {
    //   alert("상품명을 하나 이상 입력해주세요.");
    //   return;
    // }

    this.setState({ save_dialog_show_state: true, save_dialog_content: "인공지능이 추천문장을 생성중입니다."  });

    try {
      const { data } = await http.post(
        "/rest/shop/instagram/GptRecommamdSentence",
        {
          product_name_list: productNameList.map((x) => x.trim()),
          user_prompt: topicInput,
        },
        { headers: { "Content-Type": "application/json" } }
      );

      // recommendations 배열 파싱
      const recommendations = Array.isArray(data?.recommendations)
        ? data.recommendations
        : [];

      // 기본 캡션: 첫번째 문장
      const caption = recommendations[0]?.text || "";
      const selectedLabel = recommendations[0]?.label || "";

      this.setState({
        caption,
        selectedLabel,
        aiSuggestionsVisible: true,
        aiRecommendations: recommendations, // [{label, text}, ...]
        save_dialog_show_state: false,
        gpt_caption_seq : data?.gpt_call_seq || null,
      });
    } catch (err) {
      console.error("AI 추천문 생성 실패:", err);
      alert("추천 문장 생성에 실패했습니다. 잠시 후 다시 시도해주세요.");
      this.setState({
        // caption: "추천 문장 생성에 실패했습니다.",
        selectedLabel: "",
        aiSuggestionsVisible: false,
        aiRecommendations: [],
        aiLoading: false,
        save_dialog_show_state: false,
        gpt_caption_seq : null,
      });
    }
  };
  
  generateAIHashtags = async () => {
    const { caption, tags } = this.state;

    // 유효성 검사    
    // if (!imageSlots || imageSlots.length === 0) {
    //   alert("최소 한 개 이상의 이미지를 추가해주세요.");
    //   return;
    // }

    if (!caption || !caption.trim()) {
      alert("피드 문구를 입력해주세요.\n(문구를 기반으로 해시태그를 생성합니다.)");
      return;
    }
    // if (!Array.isArray(productNameList) || productNameList.length === 0) {
    //   alert("상품명을 하나 이상 입력해주세요.");
    //   return;
    // }

    this.setState({ save_dialog_show_state: true, save_dialog_content: "해시태그를 생성중입니다..."  });

    try {
      const { data } = await http.post(
        "/rest/shop/instagram/GptRecommamdHashtag",
        {
          user_prompt: caption,
          alreadyUsedHashtags: tags,
        },
        { headers: { "Content-Type": "application/json" } }
      );

      // recommendations 배열 파싱
      const hashtags = Array.isArray(data?.hashtags)
        ? data.hashtags
        : [];

      this.setState({
        tags : [...new Set([...tags, ...hashtags])],
        gpt_hashtag_seq : data?.gpt_call_seq || null,
      });
    } catch (err) {
      console.error("AI 해시태그 생성 실패:", err);
      alert("추천 해시태그 생성에 실패했습니다. 잠시 후 다시 시도해주세요.");
    } finally {
      this.setState({
        save_dialog_show_state: false,
      });
    }
  };

  // 클릭 시 해당 label의 text를 caption으로 표시
  onClickRecommendation = (text) => {
    // this.setState({ caption: text });
    this.setCaption(text);
  };


  onChangeTopic = (e) => this.setState({ topicInput: e.target.value });

  handleComposition = (e) => {
  if (e.type === 'compositionstart') this.isComposing = true;
  if (e.type === 'compositionend') {
    this.isComposing = false;
  }
};

  addHashtagOnEnter = (e) => {
    if (e.key === "Enter") {
      if (this.isComposing) return; // 조합 중이면 무시
      e.preventDefault();
      let valueRaw = e.target.value.trim();
      if (!valueRaw) return;
      valueRaw = this.sanitizeHashtag(valueRaw);
      const value = valueRaw.startsWith("#") ? valueRaw : `#${valueRaw}`;
      this.setState((prev) => {
        if (prev.tags.includes(value)) return null;
        return { tags: [...prev.tags, value] };
      });
      e.target.value = "";
    } else if (e.key === " " || e.code === "Space" || e.key === "Spacebar") {
      e.preventDefault();
    }
  };

  sanitizeHashtag = (raw) => {
    // 해시태그 앞뒤 공백 제거 후, 허용 문자만 남김
    const value = raw.replace(/[^A-Za-z0-9ㄱ-ㅎㅏ-ㅣ가-힣_]/g, '');
    return raw.startsWith("#") ? `#${value}` : value;
  };

  // 붙여넣기 시 스페이스 제거
  handlePasteHashtag = (e) => {
    e.preventDefault();
    const paste = (e.clipboardData || window.clipboardData).getData("text");
    const noSpace = paste.replace(/\s+/g, ""); // 모든 공백 제거
    const target = e.target;
    const start = target.selectionStart;
    const end = target.selectionEnd;
    const before = target.value.substring(0, start);
    const after = target.value.substring(end);

    let newValue = before + noSpace + after;
    newValue = this.sanitizeHashtag(newValue);
    target.value = newValue;

    e.target.value = newValue;
  };

  removeTagAt = (i) => {
    this.setState((prev) => {
      const tags = [...prev.tags];
      tags.splice(i, 1);
      return { tags };
    });
  };

  // ====== 발행 옵션 ======
  selectPublishOption = (type) => this.setState({ publishOption: type });

  onChangeDate = (e) => this.setState({ scheduledDate: e.target.value });
  onChangeTime = (e) => this.setState({ scheduledTime: e.target.value });

  saveDraft = () => alert("게시물이 임시 저장되었습니다.");

publishPost = async () => {
  try {
    const {
      publishOption,
      selected_ig_access_seq,
      default_ig_access_seq,
      caption,
      tags,
      scheduledDate,
      scheduledTime,
      imageSlots,
      gpt_caption_seq,
      gpt_hashtag_seq,
      aiRecommendations,
      selectedLabel,
      media_id,
      selectedFeedType,
    } = this.state;

    if (publishOption === "SCHEDULED") {
      // === 예약 발행 ===
      const filled = (imageSlots || []).filter(
        (s) => s && (s.media_source_id || s.data)
      );
      if (filled.length === 0) {
        // alert("최소 한 개 이상의 이미지가 필요합니다.");
        this.setState({ 
          warning_dialog_show_state: true, 
          warning_dialog_content: "최소 한 개 이상의 이미지가 필요합니다."
        });
        return;
      }

      if (selectedFeedType === "CAROUSEL" && filled.length < 2) {
        this.setState({ 
          warning_dialog_show_state: true, 
          warning_dialog_content: "슬라이드 이미지인 경우<br/>최소 2개의 이미지가 필요합니다."
        });
        return;
      } 
      
      if (!caption || caption.trim() === "") {
        // alert("캡션을 입력해주세요.");
        this.setState({ 
          warning_dialog_show_state: true, 
          warning_dialog_content: "캡션을 입력해주세요."
        });
        return;
      }
      
      if (!scheduledDate || !scheduledTime) {
        // alert("날짜와 시간을 선택해주세요.");
        this.setState({ 
          warning_dialog_show_state: true, 
          warning_dialog_content: "날짜와 시간을 선택해주세요."
        });
        return;
      }

      const now = new Date();
      const scheduled = new Date(`${scheduledDate}T${scheduledTime}:00`);
      if (!(scheduled.getTime() > now.getTime())) {
        // alert("예약 시각은 현재보다 이후여야 합니다.");
        this.setState({ 
          warning_dialog_show_state: true, 
          warning_dialog_content: "예약 시각은 현재보다 이후여야 합니다."
        });
        return;
      }

      this.setState({ save_dialog_show_state: true, save_dialog_content: "게시물 예약 중입니다." });

      const items = filled.map((s, idx) => {
        if (s.media_source_id) {
          return {
            item_index: idx,
            is_cover_yn: idx === 0 ? "Y" : "N",
            media_source_id: s.media_source_id,
            event_seq: s.event_seq || null,
            preview_image_url: s.preview_image_url || null
          };
        }
        const typeCd =
          (s.type === "upload" && "U") ||
          (s.type === "product" && "P") ||
          (s.type === "ai" && "A") ||
          (s.type === "template" && "T") ||
          "U";
        return {
          item_index: idx,
          is_cover_yn: idx === 0 ? "Y" : "N",
          source_type_cd: typeCd,
          source_url: s.data,
          event_seq: s.event_seq || null,
          product_no: s.product_no || null,
          stability_call_seq: s.stability_call_seq || null,
        };
      });

      const payload = {
        instagram_access_token_seq: selected_ig_access_seq || default_ig_access_seq,
        caption,
        hashtags: tags,
        scheduled_at: `${scheduledDate}T${scheduledTime}`,
        media_type_cd : (selectedFeedType === "CAROUSEL") ? "C" : (selectedFeedType === "REELS") ? "R" : "S",
        items,
        gpt_caption_seq: gpt_caption_seq || null,
        gpt_hashtag_seq: gpt_hashtag_seq || null,
        gpt_caption_suggestions: aiRecommendations ? JSON.stringify(aiRecommendations) : "[]",
        gpt_caption_selected_suggestions: selectedLabel || "",
        instagram_media_seq: media_id || null, // 편집 시 기존 media_id 포함
        image_ratio: this.state.currentRatio || "1/1",
      };

      const { data } = await http.post("/rest/shop/instagram/reservations", payload);

      this.setState({ save_dialog_show_state: false });

      if (!data || data.ok !== true) {
        alert(data && data.error ? data.error : "예약 생성 실패");
        return;
      }

      console.log(`예약 등록 완료 (ID: ${data.reservation_id})`);
      // alert(`예약 등록 완료 (ID: ${data.reservation_id})`);
      this.setState({ basic_dialog_show_state: true, basic_dialog_content: "게시물 예약이 완료되었습니다." });

      this.loadInstagramMediaDetail(data.reservation_id, true); // 발행 후 상세 재조회 (로딩 다이얼로그 없이)
      return;
    } else if (publishOption === "NOW") {
      // === 즉시 발행 ===
      const filled = (imageSlots || []).filter(
        (s) => s && (s.media_source_id || s.data)
      );
      if (filled.length === 0) {
        // alert("최소 한 개 이상의 이미지가 필요합니다.");
        this.setState({ 
          warning_dialog_show_state: true, 
          warning_dialog_content: "최소 한 개 이상의 이미지가 필요합니다."
        });
        return;
      }

      if (selectedFeedType === "CAROUSEL" && filled.length < 2) {
        this.setState({ 
          warning_dialog_show_state: true, 
          warning_dialog_content: "슬라이드 이미지인 경우<br/>최소 2개의 이미지가 필요합니다."
        });
        return;
      } 

      if (!caption || caption.trim() === "") {
        // alert("캡션을 입력해주세요.");
        this.setState({ 
          warning_dialog_show_state: true, 
          warning_dialog_content: "캡션을 입력해주세요."
        });
        return;
      }

      this.setState({ save_dialog_show_state: true, save_dialog_content: "게시물 공유 중입니다." });

      const items = filled.map((s, idx) => {
        if (s.media_source_id) {
          return {
            item_index: idx,
            is_cover_yn: idx === 0 ? "Y" : "N",
            media_source_id: s.media_source_id,
            event_seq: s.event_seq || null,
            preview_image_url: s.preview_image_url || null
          };
        }
        const typeCd =
          (s.type === "upload" && "U") ||
          (s.type === "product" && "P") ||
          (s.type === "ai" && "A") ||
          (s.type === "template" && "T") ||
          "U";
        return {
          item_index: idx,
          is_cover_yn: idx === 0 ? "Y" : "N",
          source_type_cd: typeCd,
          source_url: s.data,
          event_seq: s.event_seq || null,
          product_no: s.product_no || null,
          stability_call_seq: s.stability_call_seq || null
        };
      });

      const payload = {
        instagram_access_token_seq: selected_ig_access_seq || default_ig_access_seq,
        caption,
        hashtags: tags,
        media_type_cd : (selectedFeedType === "CAROUSEL") ? "C" : (selectedFeedType === "REELS") ? "R" : "S",
        items,
        gpt_caption_seq: gpt_caption_seq || null,
        gpt_hashtag_seq: gpt_hashtag_seq || null,
        gpt_caption_suggestions: aiRecommendations ? JSON.stringify(aiRecommendations) : "[]",
        gpt_caption_selected_suggestions: selectedLabel || "",
        instagram_media_seq: media_id || null, // 편집 시 기존 media_id 포함
        image_ratio: this.state.currentRatio || "1/1",
      };

      // 즉시 발행용 엔드포인트 (임시 → publish-now 흐름과 맞출 수도 있음)
      const { data } = await http.post("/rest/shop/instagram/media/publish-now", payload);

      this.setState({ save_dialog_show_state: false });

      if (!data || data.ok !== true) {
        alert(data && data.error ? data.error : "게시물 공유 실패");
        return;
      }

      console.log(`즉시 발행 완료 (ID: ${data.media_id})`);
      // alert(`즉시 발행이 완료되었습니다.`);
      this.setState({ basic_dialog_show_state: true, basic_dialog_content: "게시물 공유가 완료되었습니다.", basic_dialog_button_list: [{ title: "확인", event_method: () => { window.location.href = '/shop/instagram/InstagramPostList'; } }] });

      // this.loadInstagramMediaDetail(data.media_id, true); // 발행 후 상세 재조회 (로딩 다이얼로그 없이)
      return;
    }
  } catch (err) {
    this.setState({ save_dialog_show_state: false });
    console.error(err);
    alert(err.message || "발행 중 오류 발생");
  }
};

draftPost = async () => {
  try {
    const {
      imageSlots, is_draft, ...rest
    } = this.state;

    // 채워진 슬롯만 추리기 (media_source_id 있거나, 새 소스 data가 있는 경우)
    const filled = (imageSlots || []).filter(
      (s) => s && (s.media_source_id || s.data)
    );

    // 초안은 미디어가 없어도 저장 가능하게. 다만 UX상 한번 확인.
    if (filled.length === 0) {
      this.setState({ 
        confirm_dialog_show_state: true,
        confirm_dialog_content: "이미지 없이 임시 저장할까요?",
        confirm_dialog_button_list: [
          {
            title: "네",
            type: "1",
            event_method: () => {
              this.setState({ confirm_dialog_show_state: false });
              this.handleConfirmDraftSave(rest, filled);
            }
          },
          {
            title: "아니요",
            type: "2",
            event_method: () => { this.setState({ confirm_dialog_show_state: false }); }
          }
        ]
       }); 
      return; 
    }
    if (this.state.is_draft == 'N') {
      this.setState({ 
        confirm_dialog_show_state: true,
        confirm_dialog_content: "게시물을 임시저장 상태로 되돌리시겠습니까?<br/>발행은 중단되고, 수정만 가능한 상태가 됩니다.",
        confirm_dialog_button_list: [
          {
            title: "네",
            type: "1",
            event_method: () => {
              this.setState({ confirm_dialog_show_state: false })
              this.handleConfirmDraftSave(rest, filled);
            }
          },
          {
            title: "아니요",
            type: "2",
            event_method: () => { this.setState({ confirm_dialog_show_state: false }); }
          }
        ]
       }); 
       return; 
    } 

    this.handleConfirmDraftSave(rest, filled);
  } catch (err) {
    console.error(err);
    alert(err.message || "임시 저장 중 오류 발생");
  }
}

handleConfirmDraftSave = async (state, filled) => {
  try {
    this.setState({ 
      save_dialog_show_state: true, 
      save_dialog_content: "임시 저장 중입니다." 
    });

    const {
      publishOption, selected_ig_access_seq, default_ig_access_seq,
      caption, tags, scheduledDate, scheduledTime,
      gpt_caption_seq, gpt_hashtag_seq,
      aiRecommendations, selectedLabel, selectedFeedType,
      media_id
    } = state;

    const items = filled.map((s, idx) => ({
      item_index: idx,
      is_cover_yn: idx === 0 ? "Y" : "N",
      ...(s.media_source_id
        ? { media_source_id: s.media_source_id }
        : {
            source_type_cd:
              (s.type === "upload" && "U") ||
              (s.type === "product" && "P") ||
              (s.type === "ai" && "A") ||
              (s.type === "template" && "T") ||
              "U",
            source_url: s.data,
          }),
      event_seq: s.event_seq || null,
      product_no: s.product_no || null,
      stability_call_seq: s.stability_call_seq || null,
      preview_image_url: s.preview_image_url || null,
    }));

    const now = new Date();
    const defaultDate = now.toISOString().split("T")[0];
    const defaultTime = now.toTimeString().split(" ")[0].slice(0, 5);

    const payload = {
      instagram_access_token_seq: selected_ig_access_seq || default_ig_access_seq,
      caption: caption || null,
      hashtags: tags || [],
      scheduled_at: `${scheduledDate || defaultDate}T${scheduledTime || defaultTime}`,
      post_type: publishOption,
      media_type_cd:
        selectedFeedType === "CAROUSEL"
          ? "C"
          : selectedFeedType === "REELS"
          ? "R"
          : "S",
      items,
      gpt_caption_seq: gpt_caption_seq || null,
      gpt_hashtag_seq: gpt_hashtag_seq || null,
      gpt_caption_suggestions: aiRecommendations ? JSON.stringify(aiRecommendations) : "[]",
      gpt_caption_selected_suggestions: selectedLabel || "",
      image_ratio: this.state.currentRatio || "1/1",
    };

    console.log('### scheduled_at', `${scheduledDate || defaultDate}T${scheduledTime || defaultTime}`)

    // 신규 초안 or 기존 초안 업데이트
    const url = media_id
      ? `/rest/shop/instagram/media/drafts/${media_id}`
      : `/rest/shop/instagram/media/drafts`;

    const { data } = media_id
      ? await http.put(url, payload)
      : await http.post(url, payload);

    this.setState({ save_dialog_show_state: false });

    if (!data || data.ok !== true) {
      alert("임시 저장에 실패하였습니다.");
      return;
    }

    this.setState({
      basic_dialog_show_state: true,
      basic_dialog_content: "임시 저장이 완료되었습니다.",
      media_id: data.media_id,
      lastDraftId: data.media_id,
    });

    const newUrl = new URL(window.location.href);
    newUrl.searchParams.set("media_id", data.media_id);
    window.history.replaceState({}, "", newUrl);

    this.loadInstagramMediaDetail(data.media_id, true);
  } catch (err) {
    console.error(err);
    this.setState({ save_dialog_show_state: false });
    alert("임시 저장 중 오류 발생");
  }
};


  // ====== 렌더 보조 ======
  renderStepTabs() {
    const { currentStep } = this.state;
    const tab = (n, label) => {
      const active = currentStep === n;
      const completed = currentStep > n;
      return (
        <div
          key={n}
          className={`step ${active ? "active" : ""} ${completed ? "completed" : ""}`}
          onClick={() => this.goToStep(n)}
          style={{
            flex: 1,
            padding: "18px 15px",
            textAlign: "center",
            borderRight: "1px solid #dbdbdb",
            cursor: "pointer",
            background: active ? "#fff" : "#fafafa",
          }}
        >
          <span
            className="step-number"
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              width: 26,
              height: 26,
              borderRadius: "50%",
              background: completed || active ? "#00e2e6" : "#dbdbdb",
              color: "#fff",
              fontWeight: 600,
              marginRight: 8,
            }}
          >
            {n}
          </span>
          <span className="step-text" style={{ fontWeight: 600 }}>
            {label}
          </span>
        </div>
      );
    };
    return (
      <div
        className="step-indicator"
        style={{
          display: "flex",
          background: "#fafafa",
          border: "1px solid #dbdbdb",
          borderRadius: "8px 8px 0 0",
          overflow: "hidden",
        }}
      >
        {tab(1, "게시물 만들기")}
        {tab(2, "문구 작성")}
        {tab(3, "발행 설정")}
      </div>
    );
  }

  

// 채워진 슬롯 인덱스만 수집
getFilledIndices = () => {
  return (this.state.imageSlots || [])
    .map((s, idx) => (s && s.type ? idx : null))
    .filter((v) => v !== null);
};

// i번째 슬롯을 채워진 슬롯들끼리만 순서 이동
moveImage = (i, direction) => {
  const filled = this.getFilledIndices();
  const pos = filled.indexOf(i);
  if (pos < 0) return;
  const targetPos = pos + direction;
  if (targetPos < 0 || targetPos >= filled.length) return;
  const j = filled[targetPos];
  this.setState((prev) => {
    const imageSlots = [...prev.imageSlots];
    const temp = imageSlots[i];
    imageSlots[i] = imageSlots[j];
    imageSlots[j] = temp;
    return { imageSlots };
  });
};

  renderImageSlots() {
    const { imageSlots } = this.state;

    // 1. 기준 높이를 정합니다 (원하는 썸네일 높이)
    const BASE_HEIGHT = 100; 

    // 2. 현재 선택된 비율 문자열을 숫자(비율값)로 변환하는 함수
    const getRatioValue = (ratioStr) => {
      switch (ratioStr) {
        case "16/9": return 16 / 9; // 약 1.77 (가로로 김 -> 너비 넓어짐)
        case "4/5":  return 4 / 5;  // 0.8 (세로로 김 -> 너비 좁아짐)
        case "1/1":  
        default:       return 1;      // 1 (정사각형)
      }
    };

    // 3. 스타일에 적용할 minWidth 계산
    // (현재 비율에 맞는 너비를 구합니다)
    const currentRatioValue = getRatioValue(this.state.currentRatio);
    const minWidth = BASE_HEIGHT * currentRatioValue;
    const finalMinWidth = Math.max(minWidth, 100);

    return (
      <div
        className="image-slots"
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(auto-fill, minmax(${finalMinWidth}px, 1fr))`,
          gap: 12,
          margin: "20px 0",
          maxWidth: "100%",
        }}
      >
        {imageSlots.map((slot, i) => {
          const filled = !!slot.type;
          const bg =
            (slot.type === "upload" || slot.type === "ai" || slot.type === "product" || slot.type === "template") && slot.data
              ? { backgroundImage: `url(${slot.data})`, backgroundSize: "cover", backgroundPosition: "center" }
              // : slot.type === "product"
              // // ? { background: "linear-gradient(135deg, #00e2e6, #00a8ab)" }
              // ? { background: "linear-gradient(135deg, #00e2e6, #00a8ab)" }
              // : slot.type === "ai"
              // ? { background: "linear-gradient(135deg, #00e2e6, #00c5c8)" }
              // : slot.type === "template"
              // ? { background: "linear-gradient(135deg, #00a8ab, #008589)" }
              : { background: "#fafafa" };

          return (
            <div
              key={i}
              className={`image-slot ${i === 0 ? "primary" : ""} ${filled ? "filled" : ""}`}
              onClick={() => this.openImageModal(i, slot.type)}
              style={{
                aspectRatio: (this.state.currentRatio ? this.state.currentRatio : "1 / 1"),
                border: filled ? "2px solid #00e2e6" : "2px dashed #dbdbdb",
                borderRadius: 8,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
                minWidth: 100,
                cursor: "pointer",
                ...bg,
              }}
            >
              {/* 번호 */}
              <span
                className="slot-number"
                style={{
                  position: "absolute",
                  top: 8,
                  left: 8,
                  background: "rgba(0,0,0,0.7)",
                  color: "#fff",
                  width: 20,
                  height: 20,
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: 11,
                }}
              >
                {i + 1}
              </span>

              {filled ? (
                <>
                  {/* 순서 변경: ▲/▼ */}
                  <div
                    className="order-controls"
                    onClick={(e) => e.stopPropagation()}
                  >
                    {(() => {
                      const filledIdx = this.getFilledIndices();
                      const pos = filledIdx.indexOf(i);
                      const isFirst = pos === 0;
                      const isLast = pos === filledIdx.length - 1;
                      return (
                        <>
                          <button
                            className="order-btn up"
                            title="위로"
                            disabled={isFirst}
                            onClick={() => this.moveImage(i, -1)}
                            style={{ width: 24, height: 24, borderRadius: "50%", background: "rgba(255,255,255,0.95)", border: "1px solid #00e2e6", color: "#00e2e6", cursor: isFirst ? "not-allowed" : "pointer", fontWeight: 700 }}
                          >▲</button>
                          <button
                            className="order-btn down"
                            title="아래로"
                            disabled={isLast}
                            onClick={() => this.moveImage(i, +1)}
                            style={{ width: 24, height: 24, borderRadius: "50%", background: "rgba(255,255,255,0.95)", border: "1px solid #00e2e6", color: "#00e2e6", cursor: isLast ? "not-allowed" : "pointer", fontWeight: 700 }}
                          >▼</button>
                        </>
                      );
                    })()}

                    <button
                      className="delete-btn"
                      onClick={(e) => this.deleteImageAt(e, i)}
                      style={{
                        width: 24,
                        height: 24,
                        borderRadius: "50%",
                        background: "rgba(255,255,255,0.9)",
                        border: "1px solid #ff4444",
                        color: "#ff4444",
                        cursor: "pointer",
                        fontSize: 18,
                        lineHeight: 1,
                      }}
                      title="삭제"
                    >
                      ×
                    </button>
                  </div>
                  <div className="image-source-badge">{slot.type === "product" ? "상품" : slot.type === "ai" ? "AI" : slot.type === "upload" ? "파일" : "템플릿"}</div>

                  {slot.type !== "upload" && slot.type !== "ai" && slot.type !== "product" && (
                    <span style={{ color: "#fff", fontWeight: 700, textShadow: "0 1px 2px rgba(0,0,0,.2)" }}>
                      {slot.type === "product" ? "상품" : slot.type === "ai" ? "AI" : "템플릿"}
                    </span>
                  )}
                </>
              ) : (
                <>
                  {/* + 아이콘 */}
                  <div className="add-icon" style={{ width: 40, height: 40, position: "relative" }}>
                    {/* <div
                      style={{
                        position: "absolute",
                        left: "50%",
                        top: "50%",
                        width: 24,
                        height: 2,
                        transform: "translate(-50%, -50%)",
                        background: "#8e8e8e",
                      }}
                    />
                    <div
                      style={{
                        position: "absolute",
                        left: "50%",
                        top: "50%",
                        width: 2,
                        height: 24,
                        transform: "translate(-50%, -50%)",
                        background: "#8e8e8e",
                      }}
                    /> */}
                  </div>
                  {i === 0 && <span className="add-text" style={{ fontSize: 12, color: "#8e8e8e", marginTop: 8 }}>추가</span>}
                </>
              )}
            </div>
          );
        })}
      </div>
    );
  }

  renderStep1() {
    const { accountConnected, account_list, selectedAccount, selectedFeedType, imageSlots } = this.state;
    return (
      <>
        <style>
          {
            `
            /* [Updated] Ratio Badge (Right Aligned) */
            .current-ratio-info {
                font-size: 13px; color: #64748b; background: #f1f5f9; padding: 6px 12px; border-radius: 6px; font-weight: 700;
                display: flex; align-items: center; gap: 6px; border: 1px solid #e2e8f0;
            }
            .current-ratio-info::before { content: '📐'; font-size: 12px; }
            `
          }
        </style>
        <div className={`step-content ${this.state.currentStep === 1 ? "active" : ""}`} style={{ padding: 30 }}>
          <h2 style={{ marginBottom: 5 }}>게시물 등록</h2>
          <p style={{ color: "#8e8e8e", marginBottom: 30 }}>계정과 피드 유형을 선택하세요</p>

          {/* 계정 선택 */}
          <div className="content-section" style={{ marginBottom: 30 }}>
            <h3 className="section-title" style={{ fontSize: 16, marginBottom: 15 }}>
              계정 선택
            </h3>

            {accountConnected ? (
              <div id="accountList">
                {/* <select
                  className="form-control"
                  value={selectedAccount}
                  onChange={this.onChangeAccount}
                  style={{ padding: "12px 15px", fontSize: 14, width: "100%", border: "1px solid #dbdbdb", borderRadius: 6 }}
                >
                  <option value="">계정을 선택하세요</option>
                  <option value="@main_account">@main_account</option>
                  <option value="@sub_account">@sub_account</option>
                  <option value="@shop_account">@shop_account</option>
                  <option value="@brand_account">@brand_account</option>
                  <option value="@event_account">@event_account</option>
                  <option value="@test_account_01">@test_account_01</option>
                  <option value="@test_account_02">@test_account_02</option>
                  <option value="@marketing_team">@marketing_team</option>
                  <option value="@sales_team">@sales_team</option>
                  <option value="@cs_team">@cs_team</option>
                </select> */}
                <SelectBoxV2
                  id="ig_account_select"
                  tabIndex={0}
                  width="100%"
                  height="40px"
                  padding="8px 36px 8px 12px"
                  pageWrapperName="accountManagerWrap"
                  list={account_list || []}
                  optionTexttName="title"
                  optionValuetName="value"
                  selectedValue={this.state.selected_ig_access_seq || this.state.default_ig_access_seq || ""}
                  onClickOption={this.onChangeAccount}
                />
              </div>
            ) : (
              <div
                id="noAccount"
                style={{ background: "#fff8e1", border: "1px solid #ffd54f", borderRadius: 8, padding: 20 }}
              >
                <div className="noAccount_flex_box" style={{ display: "flex", alignItems: "center", gap: 15 }}>
                  <div 
                    style={{
                      width: 40,
                      height: 40,
                      background: "#ff9800",
                      borderRadius: "50%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "white",
                      fontWeight: "bold",
                      flexShrink: 0,
                    }}
                  >
                    !
                  </div>
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 600, color: "#000", marginBottom: 5 }}>Instagram 계정을 연결해주세요</div>
                    <div style={{ fontSize: 14, color: "#666" }}>
                      게시물을 업로드하려면 먼저 Instagram 계정을 연결해야 합니다.
                    </div>
                  </div>
                  <button
                    className="btn btn-black"
                    onClick={this.handleConnectAccount}
                    style={{
                      flexShrink: 0,
                      background: "#000",
                      color: "white",
                      padding: "12px 24px",
                      borderRadius: 6,
                      border: "none",
                      fontWeight: 600,
                      fontSize: 14,
                      cursor: "pointer",
                    }}
                  >
                    계정 연결하기
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* 피드 유형 */}
          <div id="feedTypeSection" className="content-section" style={{ marginBottom: 30 }}>
            <h3 className="section-title" style={{ fontSize: 16, marginBottom: 15 }}>
              피드 구성 방법
            </h3>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(150px,1fr))", gap: 15 }}>
              {[
                { key: "SINGLE", icon: "🖼️", title: "단일 이미지", sub: "이미지 1개" },
                { key: "CAROUSEL", icon: "🎠", title: "슬라이드 이미지", sub: "이미지 최대 10개" },
                // { key: "REELS", icon: "🎬", title: "릴스", sub: "동영상" },
              ].map((opt) => (
                <div
                  key={opt.key}
                  className={`feed-type-option ${selectedFeedType === opt.key ? "selected" : ""}`}
                  onClick={() => this.selectFeedType(opt.key)}
                  style={{
                    border: "2px solid " + (selectedFeedType === opt.key ? "#00e2e6" : "#dbdbdb"),
                    borderRadius: 8,
                    padding: 20,
                    textAlign: "center",
                    cursor: "pointer",
                    background: selectedFeedType === opt.key ? "rgba(0,226,230,.05)" : "#fff",
                  }}
                >
                  <div style={{ fontSize: 32, marginBottom: 8 }}>{opt.icon}</div>
                  <div style={{ fontWeight: 600, marginBottom: 5 }}>{opt.title}</div>
                  <div style={{ fontSize: 12, color: "#8e8e8e" }}>{opt.sub}</div>
                </div>
              ))}
            </div>
          </div>

          {/* 이미지 선택 (reels 제외) */}
          {this.state.selectedFeedType !== "REELS" && (
            <div id="imageSelectionArea" className="content-section">
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 15 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <h3 style={{ fontSize: 16, margin: 0 }}>이미지 선택</h3>
                  {
                    this.state.currentRatioText
                    &&
                    <div id="statusText" class="current-ratio-info">{this.state.currentRatioText}</div>
                  }
                </div>
                {this.state.selectedFeedType === "CAROUSEL" && (
                  <button
                    className="btn btn-primary"
                    onClick={this.addNewImageSlot}
                    style={{ padding: "8px 16px", fontSize: 14 }}
                  >
                    + 이미지 추가
                  </button>
                )}
              </div>

              {this.renderImageSlots()}

              <p style={{ fontSize: 12, color: "#8e8e8e", marginTop: 8 }}>
                {this.state.selectedFeedType === "SINGLE" ? (
                  "단일 이미지 모드"
                ) : (
                  <>
                    슬라이드는 최대 10개까지 추가 가능합니다.{" "}
                    <span style={{ color: "#00e2e6", fontWeight: 600 }}>
                      이미지 위에 마우스를 올리면 순서 조정 버튼이 나타납니다.
                    </span>
                  </>
                )}
              </p>
            </div>
          )}

          <div className="navigation-buttons" style={{ display: "flex", justifyContent: "space-between", marginTop: 30, paddingTop: 20, borderTop: "1px solid #dbdbdb" }}>
            <div />
            <button className="btn btn-primary" onClick={() => this.goToStep(2)}>
              다음: 문구 작성 →
            </button>
          </div>
        </div>
      </>
    );
  }

  renderStep2() {
    const { caption, selectedAccount, aiSuggestionsVisible, tags, topicInput, inputHashtagValue } = this.state;
    const previewAccount = selectedAccount || {title: "계정명 없음", profile_picture_url: null};
    const hashtagText = tags.join(" ");
    const charCount = caption.length;

    return (
      <div className={`step-content ${this.state.currentStep === 2 ? "active" : ""}`} style={{ padding: 30 }}>
        <div className="caption-section" style={{ display: "flex", gap: 30, flexWrap: "wrap" }}>
          {/* 미리보기 */}
          <div className="caption-preview" style={{ display: "none" }}>
            <div className="instagram-preview" style={{ background: "#fff", border: "1px solid #dbdbdb", borderRadius: 8, overflow: "hidden" }}>
              <div className="insta-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 16px", borderBottom: "1px solid #efefef" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <div style={{ width: 32, height: 32, borderRadius: "50%", background: "#ddd" }}>
                    <img src={previewAccount.profile_picture_url || "https://via.placeholder.com/32"} alt="Profile" style={{ width: "100%", height: "100%", borderRadius: "50%" }} 
                      onError={(e) => {
                        e.currentTarget.onerror = null; // 루프 방지
                        e.currentTarget.style.display = 'none';
                      }}
                    />
                  </div>
                  <span id="previewAccount" style={{ fontWeight: 600, fontSize: 14 }}>
                    {previewAccount.title}
                  </span>
                </div>
                <span style={{ color: "#262626" }}>⋯</span>
              </div>
              <div
                className="preview-image"
                style={{
                  width: "100%",
                  aspectRatio: (this.state.currentRatio ? this.state.currentRatio : "1 / 1"),
                  background: "linear-gradient(135deg, #00e2e6, #00a8ab)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div style={{ textAlign: "center", color: "white" }}>
                  <div style={{ fontSize: 48, marginBottom: 10 }}>🎨</div>
                  <div style={{ fontSize: 18, fontWeight: 600 }}>AI 생성 이미지</div>
                </div>
              </div>
              <div className="insta-actions" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 16px" }}>
                <div style={{ display: "flex", gap: 16 }}>
                  <span style={{ fontSize: 24 }}>
                    <img src={"https://s3.ap-northeast-2.amazonaws.com/otdeal.file/icn_intagram/icon-like.svg"} style={{ width: 24, height: 24 }}></img>
                  </span>
                  <span style={{ fontSize: 24 }}>
                    <img src={"https://s3.ap-northeast-2.amazonaws.com/otdeal.file/icn_intagram/comment.svg"} style={{ width: 24, height: 24 }}></img>
                  </span>
                  <span style={{ fontSize: 24 }}>
                    <img src={"https://s3.ap-northeast-2.amazonaws.com/otdeal.file/icn_intagram/share.svg"} style={{ width: 24, height: 24 }}></img>
                  </span>
                </div>
                <span style={{ fontSize: 24 }}>
                  <img src={"https://s3.ap-northeast-2.amazonaws.com/otdeal.file/icn_intagram/bookmark.svg"} style={{ width: 24, height: 24 }}></img>
                </span>
              </div>
              <div className="insta-caption" style={{ padding: "0 16px 16px", maxHeight: 150, overflowY: "auto" }}>
                <div style={{ fontWeight: 600, marginBottom: 8 }}>
                  <span id="previewAccountName">{previewAccount.title}</span>
                </div>
                <div id="previewCaption" style={{ fontSize: 14, color: "#262626", whiteSpace: "pre-wrap" }}>
                  {caption || "여기에 작성한 문구가 실시간으로 표시됩니다."}
                </div>
                <div id="previewHashtags" style={{ color: "#00376b", marginTop: 8, fontSize: 14 }}>
                  {hashtagText}
                </div>
              </div>
            </div>
          </div>

          {/* 작성 폼 */}
          <div className="caption-form" style={{ flex: 1, minWidth: "100%" }}>
            <h2 style={{ marginBottom: 20 }}>문구 작성</h2>

            <div className="form-group" style={{ marginBottom: 25 }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8, position: "relative" }}>
                <label className="form-label" style={{ marginBottom: 0, fontWeight: 600 }}>
                  피드 문구
                </label>
                <div className="flexBox" style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "nowrap" }}>
                  <button
                    // className={"btn btn-secondary"+(this.state.emojiPickerVisible ? " active" : "")}
                    // id="emojiPickerBtn"
                    // onClick={this.showEmojiPicker}
                    onClick={this.undoCaption}
                    style={{ padding: "6px 12px", fontSize: 13, background: "#f3f4f6", color: "#6b7280", border: "1px solid #e5e7eb", borderRadius: 6, width: "60px", height: "33px" }}
                    // onMouseDown={(e) => e.preventDefault()}
                  >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21.7501 18.75C21.7501 18.9489 21.6711 19.1397 21.5304 19.2803C21.3898 19.421 21.199 19.5 21.0001 19.5C20.8012 19.5 20.6104 19.421 20.4698 19.2803C20.3291 19.1397 20.2501 18.9489 20.2501 18.75C20.2476 16.5627 19.3776 14.4657 17.831 12.9191C16.2844 11.3725 14.1874 10.5025 12.0001 10.5H4.81041L8.03073 13.7194C8.17146 13.8601 8.25052 14.051 8.25052 14.25C8.25052 14.449 8.17146 14.6399 8.03073 14.7806C7.89 14.9213 7.69912 15.0004 7.5001 15.0004C7.30108 15.0004 7.11021 14.9213 6.96948 14.7806L2.46948 10.2806C2.39974 10.211 2.34442 10.1282 2.30668 10.0372C2.26894 9.94615 2.24951 9.84855 2.24951 9.74999C2.24951 9.65143 2.26894 9.55383 2.30668 9.46278C2.34442 9.37174 2.39974 9.28902 2.46948 9.21936L6.96948 4.71936C7.11021 4.57863 7.30108 4.49957 7.5001 4.49957C7.69912 4.49957 7.89 4.57863 8.03073 4.71936C8.17146 4.8601 8.25052 5.05097 8.25052 5.24999C8.25052 5.44901 8.17146 5.63988 8.03073 5.78061L4.81041 8.99999H12.0001C14.5851 9.00272 17.0635 10.0308 18.8914 11.8587C20.7193 13.6866 21.7474 16.165 21.7501 18.75Z" fill="#333333"/>
                    </svg>
                  </button>
                  <button
                    // className={"btn btn-secondary"+(this.state.emojiPickerVisible ? " active" : "")}
                    // id="emojiPickerBtn"
                    // onClick={this.showEmojiPicker}
                    onClick={this.redoCaption}
                    style={{ padding: "6px 12px", fontSize: 13, background: "#f3f4f6", color: "#6b7280", border: "1px solid #e5e7eb", borderRadius: 6, width: "60px", height: "33px" }}
                    // onMouseDown={(e) => e.preventDefault()}
                  >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M21.5306 10.2806L17.0306 14.7806C16.8899 14.9213 16.699 15.0004 16.5 15.0004C16.301 15.0004 16.1101 14.9213 15.9694 14.7806C15.8286 14.6399 15.7496 14.449 15.7496 14.25C15.7496 14.051 15.8286 13.8601 15.9694 13.7194L19.1897 10.5H12C9.81273 10.5025 7.71575 11.3725 6.16911 12.9191C4.62247 14.4657 3.75248 16.5627 3.75 18.75C3.75 18.9489 3.67098 19.1397 3.53033 19.2803C3.38968 19.421 3.19891 19.5 3 19.5C2.80109 19.5 2.61032 19.421 2.46967 19.2803C2.32902 19.1397 2.25 18.9489 2.25 18.75C2.25273 16.165 3.28084 13.6866 5.10872 11.8587C6.93661 10.0308 9.41498 9.00272 12 8.99999H19.1897L15.9694 5.78061C15.8997 5.71093 15.8444 5.62821 15.8067 5.53716C15.769 5.44612 15.7496 5.34854 15.7496 5.24999C15.7496 5.15144 15.769 5.05386 15.8067 4.96282C15.8444 4.87177 15.8997 4.78905 15.9694 4.71936C16.1101 4.57863 16.301 4.49957 16.5 4.49957C16.5985 4.49957 16.6961 4.51898 16.7872 4.55669C16.8782 4.59441 16.9609 4.64968 17.0306 4.71936L21.5306 9.21936C21.6004 9.28902 21.6557 9.37174 21.6934 9.46278C21.7312 9.55383 21.7506 9.65143 21.7506 9.74999C21.7506 9.84855 21.7312 9.94615 21.6934 10.0372C21.6557 10.1282 21.6004 10.211 21.5306 10.2806Z" fill="#333333"/>
                    </svg>
                  </button>
                  <button
                    className={"btn btn-secondary"+(this.state.emojiPickerVisible ? " active" : "")}
                    id="emojiPickerBtn"
                    onClick={this.showEmojiPicker}
                    style={{ padding: "6px 12px", fontSize: 13, background: "#f3f4f6", color: "#6b7280", border: "1px solid #e5e7eb", borderRadius: 6, height: "33px" }}
                    onMouseDown={(e) => e.preventDefault()}
                  >
                    😊 이모티콘 삽입
                  </button>
                </div>
                {
                  // 이모지 선택기
                  this.state.emojiPickerVisible &&
                  <Picker data={data}
                      categories={["frequent", "people", "nature", "foods", "activity", "places", "objects", "symbols", "flags"]}
                      onEmojiSelect={emoji => this.handleEmojiSelect(emoji)}
                  />
                }
              </div>
              <textarea
                ref={this.captionTextareaRef}
                className="form-control"
                placeholder="게시물 문구를 입력하세요..."
                maxLength={2200}
                value={caption}
                onChange={this.onChangeCaption}
                style={{ width: "100%", minHeight: 120, padding: 12, border: "1px solid #dbdbdb", borderRadius: 6, fontSize: 14 }}
              />
              <div className="char-count" style={{ textAlign: "right", fontSize: 12, color: "#8e8e8e", marginTop: 5 }}>
                {charCount}/2,200
              </div>
            </div>

            <div
              className="form-group"
              style={{
                background: "rgba(0,226,230,0.05)",
                padding: 15,
                borderRadius: 8,
                border: "1px solid #00e2e6",
                marginBottom: 25,
              }}
            >
              <label className="form-label" style={{ fontWeight: 600 }}>
                🤖 AI 문구 도우미 <span className="ai-badge" style={{ fontSize: 10, marginLeft: 6, background: "linear-gradient(45deg,#00e2e6,#00a8ab)", color: "#fff", padding: "2px 6px", borderRadius: 4 }}>AI</span>
              </label>
              <div className="ai-input-group" style={{ display: "flex", gap: 10, marginBottom: 15 }}>
                {/* <input
                  type="text"
                  className="form-control"
                  placeholder="예: 신제품 홍보, 일상 공유, 이벤트 안내 등"
                  value={topicInput}
                  onChange={this.onChangeTopic}
                  style={{ flex: 1, padding: 12, border: "1px solid #dbdbdb", borderRadius: 6, fontSize: 14 }}
                /> */}
                <div style={{ flex: 1 }}>
                  <TextInput
                    type="text"
                    id="topicInput"
                    placeholder="예: 신제품 홍보, 일상 공유, 이벤트 안내 등"
                    value={topicInput}
                    onChange={(e, value) => this.onChangeTopic(e, value)}
                    width="100%"
                    padding="12px"
                    fontSize="14px"
                    background="#fff"
                  />
                </div>
                <button className="btn btn-primary" onClick={this.generateAICaption} style={{ padding: "12px 24px" }}>
                  문구 만들기
                </button>
              </div>
              <p style={{ fontSize: 12, color: "#8e8e8e", marginTop: 8 }}>
                원하는 문구의 주제나 분위기를 입력하면 AI가 작성해드립니다
              </p>

              {aiSuggestionsVisible && (
                <div
                  className="ai-suggestions"
                  style={{
                    marginTop: 15,
                    border: "1px solid #00e2e6",
                    borderRadius: 8,
                    padding: 12,
                    background: "linear-gradient(135deg, rgba(0,226,230,0.05), #fff)",
                  }}
                >
                  <p
                    style={{
                      fontSize: 14,
                      marginBottom: 10,
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <strong>AI가 생성한 문구 예시</strong>
                    <span
                      className="ai-badge"
                      style={{
                        fontSize: 10,
                        marginLeft: 6,
                        background: "linear-gradient(45deg,#00e2e6,#00a8ab)",
                        color: "#fff",
                        padding: "2px 6px",
                        borderRadius: 4,
                      }}
                    >
                      AI
                    </span>

                    {this.state.aiLoading && (
                      <span style={{ marginLeft: 8, fontSize: 11, color: "#00a8ab" }}>
                        생성 중…
                      </span>
                    )}
                    {!this.state.aiLoading && this.state.aiError && (
                      <span style={{ marginLeft: 8, fontSize: 11, color: "#d9534f" }}>
                        {String(this.state.aiError)}
                      </span>
                    )}
                  </p>

                  <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                    {this.state.aiRecommendations?.length > 0
                      && this.state.aiRecommendations.map((rec, idx) => {
                          const isActive = this.state.selectedLabel === rec.label;
                          return (
                            <button
                              key={idx}
                              className="btn btn-secondary"
                              title={rec.text}
                              style={{
                                fontSize: 12,
                                padding: "6px 12px",
                                border: isActive
                                  ? "1px solid #00a8ab"
                                  : "1px solid rgba(0,0,0,0.08)",
                                background: isActive
                                  ? "linear-gradient(45deg,#e8fbfb,#ffffff)"
                                  : undefined,
                              }}
                              onClick={() => this.useSuggestion(rec.label)}
                            >
                              {rec.label}
                            </button>
                          );
                        })
                      // : ["신상품", "할인", "브랜드"].map((label) => {
                      //     const isActive = this.state.selectedLabel === label;
                      //     return (
                      //       <button
                      //         key={label}
                      //         className="btn btn-secondary"
                      //         style={{
                      //           fontSize: 12,
                      //           padding: "6px 12px",
                      //           border: isActive
                      //             ? "1px solid #00a8ab"
                      //             : "1px solid rgba(0,0,0,0.08)",
                      //           background: isActive
                      //             ? "linear-gradient(45deg,#e8fbfb,#ffffff)"
                      //             : undefined,
                      //         }}
                      //         onClick={() => this.useSuggestion(label)}
                      //       >
                      //         {label}
                      //       </button>
                      //     );
                      // })
                      }
                  </div>
                </div>
              )}
            </div>

            {/* 해시태그 */}
            <div className="form-group" style={{ marginBottom: 25 }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                <label className="form-label" style={{ marginBottom: 0, fontWeight: 600 }}>
                  해시태그
                </label>
                <button className="btn btn-primary" onClick={this.generateAIHashtags} style={{ padding: "6px 16px", fontSize: 13, height: "28px" }}>
                  + AI로 찾기
                </button>
              </div>

              <div className="tags-input" style={{ display: "flex", flexWrap: "wrap", gap: 8, padding: 8, border: "1px solid #dbdbdb", borderRadius: 6, minHeight: 40 }}>
                <DndContext
                    sensors={sensors}
                    collisionDetection={closestCenter}
                    onDragEnd={this.handleDragEnd}
                >
                  <SortableContext
                    items={tags.map(item => item)}
                    strategy={rectSortingStrategy}
                    >
                      <div>
                      {tags.map((t, i) => (
                        <SortableTag
                          key={t}         // t가 문자열이고 고유해야 함
                          id={t}
                          onRemove={() => this.removeTagAt(i)}
                        >
                          {t}
                        </SortableTag>
                      ))}
                      </div>
                  </SortableContext>
                </DndContext>
              </div>
              {/* <input
                type="text"
                className="form-control"
                placeholder="해시태그 추가 (Enter)"
                onKeyDown={this.addHashtagOnEnter}
                style={{ marginTop: 10, padding: 12, border: "1px solid #dbdbdb", borderRadius: 6 }}
              /> */}
              <div style={{ marginTop: 10 }}>
                <TextInput
                  type="text"
                  id="hashtagInput"
                  placeholder="해시태그 추가 (Enter)"
                  onKeyDown={this.addHashtagOnEnter}
                  onCompositionStart={this.handleComposition}
                  onCompositionEnd={this.handleComposition}
                  onPaste={this.handlePasteHashtag}
                  width="100%"
                  padding="12px"
                />
              </div>
            </div>

            {/* 추가 설정 (예: 인물 태그/제품 태그) */}
            {/* <div className="additional-options" style={{ borderTop: "1px solid #dbdbdb", paddingTop: 20 }}>
              <h3 style={{ marginBottom: 15, fontSize: 16 }}>추가 설정</h3>

              <div className="option-row" onClick={() => alert("인물 태그")} style={{ display: "flex", alignItems: "center", padding: "12px 0", borderBottom: "1px solid #efefef", cursor: "pointer" }}>
                <span className="option-icon" style={{ width: 40, fontSize: 20 }}>👥</span>
                <span className="option-label" style={{ flex: 1, fontSize: 14 }}>인물 태그</span>
                <span className="option-value" style={{ color: "#8e8e8e", fontSize: 14, marginRight: 10 }}>0명</span>
                <span className="option-arrow" style={{ color: "#8e8e8e" }}>›</span>
              </div>

              <div className="option-row" onClick={() => alert("카탈로그 제품 태그")} style={{ display: "flex", alignItems: "center", padding: "12px 0", borderBottom: "1px solid #efefef", cursor: "pointer" }}>
                <span className="option-icon" style={{ width: 40, fontSize: 20 }}>🛍️</span>
                <span className="option-label" style={{ flex: 1, fontSize: 14 }}>카탈로그 제품 태그</span>
                <span className="option-value" style={{ color: "#8e8e8e", fontSize: 14, marginRight: 10 }}>추가</span>
                <span className="option-arrow" style={{ color: "#8e8e8e" }}>›</span>
              </div>
            </div> */}
          </div>
        </div>

        <div className="navigation-buttons" style={{ display: "flex", justifyContent: "space-between", marginTop: 30, paddingTop: 20, borderTop: "1px solid #dbdbdb" }}>
          <button className="btn btn-secondary" onClick={() => this.goToStep(1)}>
            ← 이전
          </button>
          <button className="btn btn-primary" onClick={() => this.goToStep(3)}>
            다음: 발행 설정 →
          </button>
        </div>
      </div>
    );
  }

  renderStep3() {
    const { publishOption, scheduledDate, scheduledTime } = this.state;
    return (
      <div className={`step-content ${this.state.currentStep === 3 ? "active" : ""}`} style={{ padding: 30 }}>
        <h2 style={{ marginBottom: 5 }}>발행 설정</h2>
        <p style={{ color: "#8e8e8e", marginBottom: 30 }}>게시물을 언제 공유할지 선택하세요</p>

        <div className="publish-options" style={{ display: "flex", flexDirection: "column", gap: 20 }}>
          <div
            className={`publish-option ${publishOption === "NOW" ? "selected" : ""}`}
            onClick={() => this.selectPublishOption("NOW")}
            style={{
              padding: 20,
              border: "1px solid " + (publishOption === "NOW" ? "#00e2e6" : "#dbdbdb"),
              borderRadius: 8,
              background: publishOption === "NOW" ? "rgba(0,226,230,.05)" : "#fff",
              cursor: "pointer",
            }}
          >
            <h3 style={{ marginBottom: 10 }}>🚀 지금 공유</h3>
            <p style={{ color: "#8e8e8e", fontSize: 14 }}>즉시 게시물을 공유합니다</p>
          </div>

          <div
            className={`publish-option ${publishOption === "SCHEDULED" ? "selected" : ""}`}
            onClick={() => this.selectPublishOption("SCHEDULED")}
            style={{
              padding: 20,
              border: "1px solid " + (publishOption === "SCHEDULED" ? "#00e2e6" : "#dbdbdb"),
              borderRadius: 8,
              background: publishOption === "SCHEDULED" ? "rgba(0,226,230,.05)" : "#fff",
              cursor: "pointer",
            }}
          >
            <h3 style={{ marginBottom: 10 }}>📅 예약 게시</h3>
            <p style={{ color: "#8e8e8e", fontSize: 14, marginBottom: 15 }}>
              원하는 시간에 자동으로 게시됩니다
            </p>

            <div className="datetime-picker" style={{ display: "flex", gap: 10 }}>
              <div style={{flex: 1}}>
              {/* 날짜 전용 */}
              <DatePicker
                selected={this.getDateObjForDate()}
                onChange={this.onChangeDatePicker}
                dateFormat="yyyy-MM-dd"
                locale={ko}
                placeholderText="날짜 선택"
                className="form-control"
                wrapperClassName="form-control"
                // minDate={new Date()} // 오늘 이후만 허용하려면
              />
              </div>
              <div style={{flex: 1}}>
              {/* 시간 전용 */}
              <DatePicker
                selected={this.getDateObjForTime()}
                onChange={this.onChangeTimePicker}
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={60}
                timeCaption="시간"
                locale={ko}
                placeholderText="시간 선택"
                className="form-control"
                wrapperClassName="form-control"
                // 선택 가능한 시간대를 제한하려면 (예: 06:00~23:00)
                // minTime={new Date(`1970-01-01T06:00:00`)}
                // maxTime={new Date(`1970-01-01T23:00:00`)}
                dateFormat="aa hh:mm"
                timeFormat="aa hh:mm"
                renderCustomHeader={({ date, changeTime }) => {
                  const hours = Array.from({ length: 12 }, (_, i) => i + 1);
                  return (
                    <div style={{ textAlign: 'center', padding: '4px' }}>
                      {hours.map(h => (
                        <button
                          key={h}
                          onClick={() => {
                            const newDate = new Date(date);
                            newDate.setHours(h);
                            changeTime(newDate);
                          }}
                          style={{ margin: '0 4px' }}
                        >
                          {`오${h < 12 ? '전' : '후'} ${String(h).padStart(2, '0')}:00`}
                        </button>
                      ))}
                    </div>
                  );
                }}
              />
              </div>
            </div>
          </div>

          <div
            className="ai-suggestions"
            style={{
              background: "linear-gradient(135deg, rgba(0,226,230,0.05), #fff)",
              borderRadius: 8,
              padding: 15,
              border: "1px solid #00e2e6",
            }}
          >
            <p style={{ fontSize: 14, marginBottom: 10 }}>
              <strong>🎯 AI 추천 시간</strong>{" "}
              <span className="ai-badge" style={{ fontSize: 10, marginLeft: 6, background: "linear-gradient(45deg,#00e2e6,#00a8ab)", color: "#fff", padding: "2px 6px", borderRadius: 4 }}>
                AI
              </span>
            </p>
            <p style={{ fontSize: 13, color: "#000" }}>
              • 평일 오후 2-3시 (도달율 최고)
              <br />• 저녁 7-8시 (참여율 최고)
            </p>
          </div>
        </div>

        <div className="navigation-buttons" style={{ display: "flex", justifyContent: "space-between", marginTop: 30, paddingTop: 20, borderTop: "1px solid #dbdbdb" }}>
          <button className="btn btn-secondary" onClick={() => this.goToStep(2)}>
            ← 이전
          </button>
          <div>
            <button className="btn btn-secondary" onClick={this.draftPost} style={{ marginRight: 8 }}>
              임시 저장
            </button>
            <button className="btn btn-primary" onClick={this.publishPost}>
              {
                publishOption === "NOW"
                ? "게시물 공유"
                : "게시물 예약"
              }
            </button>
          </div>
        </div>
      </div>
    );
  }

  getDateObjForDate = () => {
    const { scheduledDate, scheduledTime } = this.state;
    if (!scheduledDate) return null;
    // 시간 문자열이 있으면 함께 넣어도 되고, 없어도 날짜만 OK
    const time = scheduledTime || "00:00";
    return new Date(`${scheduledDate}T${time}:00`);
  };

  getDateObjForTime = () => {
    const { scheduledDate, scheduledTime } = this.state;
    // 시간 전용 피커는 기준 날짜가 필요하므로, 선택된 날짜가 있으면 그 날짜 사용
    const baseDate = scheduledDate ? scheduledDate : format(new Date(), "yyyy-MM-dd");
    const time = scheduledTime || "00:00";
    return new Date(`${baseDate}T${time}:00`);
  };

  onChangeDatePicker = (date) => {
    if (!date) {
      this.setState({ scheduledDate: "" });
      return;
    }
    this.setState({ scheduledDate: format(date, "yyyy-MM-dd") });
  };

  onChangeTimePicker = (date) => {
    if (!date) {
      this.setState({ scheduledTime: "" });
      return;
    }
    this.setState({ scheduledTime: format(date, "HH:mm") });
  };

  handleConnectAccount = () => {
    const authUrl = `https://www.facebook.com/v24.0/dialog/oauth?` +
      `client_id=${FACEBOOK_APP_ID}` +
      `&redirect_uri=${encodeURIComponent(REDIRECT_URI)}` +
      `&scope=${SCOPES}` +
      `&response_type=code`
      ;

    window.open(authUrl);
  };

  // ====== 메인 렌더 ======
  

// 공통 미리보기: 모든 스텝 외부에 1회만 렌더
  

// 미리보기용 채워진 이미지 배열 (data만 반환)
getFilledImages = () => {
  const { imageSlots } = this.state;
  // return imageSlots.filter(s => s && s.type && s.data).map(s => s.data);
  return imageSlots.filter(s => s && s.type).map(s => s.data);
  // return imageSlots;
};

setSlide = (idx) => {
  const imgs = this.getFilledImages();
  if (!imgs.length) return;
  const next = ((idx % imgs.length) + imgs.length) % imgs.length;
  this.setState({ previewSlideIndex: next });
};

nextSlide = () => {
  const { previewSlideIndex = 0 } = this.state;
  this.setSlide(previewSlideIndex + 1);
};

previousSlide = () => {
  const { previewSlideIndex = 0 } = this.state;
  this.setSlide(previewSlideIndex - 1);
};


// 공통 미리보기 (1~3 스텝 밖, 우측 고정 패널에서 1회 렌더)
renderPreviewCard() {
  const { selectedAccount, caption = "", tags = [], previewSlideIndex = 0 } = this.state;
  const previewAccount = selectedAccount || {title: "계정명 없음", profile_picture_url: null};

  // 채워진 이미지들만 수집 (dataURL 등)
  const imgs = this.getFilledImages();
  const total = imgs.length || 1;
  const hasSlides = total > 1;
  const currentIdx = imgs.length ? ((previewSlideIndex % total) + total) % total : 0;

  // 현재 슬라이드 배경
  const bgStyle = imgs.length
    ? { backgroundImage: `url(${imgs[currentIdx]})`, backgroundSize: "cover", backgroundPosition: "center" }
    : { background: "linear-gradient(135deg, #00e2e6, #00a8ab)" };

  return (
    <div className="instagram-preview" style={{ background: "#fff", border: "1px solid #dbdbdb", borderRadius: 8, overflow: "hidden" }}>
      {/* 헤더 */}
      <div className="insta-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 16px", borderBottom: "1px solid #efefef" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <div style={{ width: 32, height: 32, borderRadius: "50%", background: "#ddd" }}>
            <img src={previewAccount.profile_picture_url || "https://via.placeholder.com/32"} alt="Profile" style={{ width: "100%", height: "100%", borderRadius: "50%" }} 
              onError={(e) => {
                e.currentTarget.onerror = null; // 루프 방지
                e.currentTarget.style.display = 'none';
              }}
            />
          </div>
          <span id="previewAccount" style={{ fontWeight: 600, fontSize: 14 }}>{previewAccount.title}</span>
        </div>
        <span style={{ color: "#262626" }}>⋯</span>
      </div>

      {/* 이미지 컨테이너 */}
      <div className="preview-image-container" style={{ position: "relative" }}>
        <div
          className="preview-image"
          id="previewImage"
          style={{ width: "100%", aspectRatio: (this.state.currentRatio ? this.state.currentRatio : "1 / 1"),  borderRadius: "0px", display: "flex", alignItems: "center", justifyContent: "center", ...bgStyle }}
        >
          {!imgs.length && (
            <div style={{ textAlign: "center", color: "white" }}>
              <div style={{ fontSize: 48, marginBottom: 10 }}>🎨</div>
              <div style={{ fontSize: 18, fontWeight: 600 }}>선택된 이미지</div>
            </div>
          )}
        </div>

        {/* 슬라이드 인디케이터 */}
        {hasSlides && (
          <div id="slideIndicators" style={{ display: "flex", position: "absolute", bottom: 10, left: "50%", transform: "translateX(-50%)", gap: 6, zIndex: 5 }}>
            {imgs.map((_, i) => (
              <span
                key={i}
                onClick={() => this.setSlide(i)}
                style={{ width: 6, height: 6, borderRadius: "50%", background: i === currentIdx ? "#fff" : "rgba(255,255,255,0.5)", cursor: "pointer" }}
              />
            ))}
          </div>
        )}

        {/* 슬라이드 네비게이션 */}
        {hasSlides && (
          <div id="slideNavigation" style={{ zIndex: 5, pointerEvents: "none" }}>
            <button
              onClick={this.previousSlide}
              style={{ position: "absolute", left: 10, top: "50%", transform: "translateY(-50%)", background: "rgba(0,0,0,0.5)", color: "white", border: "none", borderRadius: "50%", width: 32, height: 32, cursor: "pointer", pointerEvents: "auto" }}
            >
              ‹
            </button>
            <button
              onClick={this.nextSlide}
              style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)", background: "rgba(0,0,0,0.5)", color: "white", border: "none", borderRadius: "50%", width: 32, height: 32, cursor: "pointer", pointerEvents: "auto" }}
            >
              ›
            </button>
          </div>
        )}

        {/* 슬라이드 카운터 */}
        {hasSlides && (
          <div id="slideCounter" style={{ position: "absolute", top: 10, right: 10, background: "rgba(0,0,0,0.7)", color: "white", padding: "4px 8px", borderRadius: 12, fontSize: 12 }}>
            <span id="currentSlideNum">{currentIdx + 1}</span> / <span id="totalSlides">{total}</span>
          </div>
        )}
      </div>

      {/* 액션 */}
      <div className="insta-actions" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 16px" }}>
        <div style={{ display: "flex", gap: 16 }}>
          <span style={{ fontSize: 24 }}>
            <img src={"https://s3.ap-northeast-2.amazonaws.com/otdeal.file/icn_intagram/icon-like.svg"} style={{ width: 24, height: 24 }}></img>
          </span>
          <span style={{ fontSize: 24 }}>
            <img src={"https://s3.ap-northeast-2.amazonaws.com/otdeal.file/icn_intagram/comment.svg"} style={{ width: 24, height: 24 }}></img>
          </span>
          <span style={{ fontSize: 24 }}>
            <img src={"https://s3.ap-northeast-2.amazonaws.com/otdeal.file/icn_intagram/share.svg"} style={{ width: 24, height: 24 }}></img>
          </span>
        </div>
        <span style={{ fontSize: 24 }}>
          <img src={"https://s3.ap-northeast-2.amazonaws.com/otdeal.file/icn_intagram/bookmark.svg"} style={{ width: 24, height: 24 }}></img>
        </span>
      </div>

      {/* 캡션 */}
      <div className="insta-caption" style={{ padding: "0 16px 16px", maxHeight: 150, overflowY: "auto" }}>
        <div style={{ fontWeight: 600, marginBottom: 8 }}>
          <span id="previewAccountName">{previewAccount.title}</span>
        </div>
        <div id="previewCaption" style={{ fontSize: 14, color: "#262626", whiteSpace: "pre-wrap" }}>
          {caption || "여기에 작성한 문구가 실시간으로 표시됩니다."}
        </div>
        <div id="previewHashtags" style={{ color: "#00376b", marginTop: 8, fontSize: 14 }}>
          {(tags || []).join(" ")}
        </div>
      </div>
    </div>
  );
}

applyAIImg(img, stability_call_seq){
  this.setState((prev) => {           
    const imageSlots = [...prev.imageSlots];
    imageSlots[this.state.currentImageSlotIndex] = { type: "ai", data: img, stability_call_seq: stability_call_seq };
    return { imageSlots };
  });
}

onClickAddProductbtn(selected_product_list){
   this.setState({ 
    show_add_product_popup:false,
    save_dialog_show_state: true
   });
    const config = {
      headers: {
          'Content-Type': 'application/json',
      }
    }
    
    const body = {
      image_url: selected_product_list[0].image_url,
      ratio: this.state.currentRatio ? this.state.currentRatio : "1/1",
    }

    http.post("/rest/shop/instagram/resizeUrlImg", body, config)
    .then(res => {
        const url = res.data.org_img_path;
        this.setSelectedProduct(selected_product_list, url);
        this.setState({ save_dialog_show_state: false });
      }).catch(error => {
        console.log (error);
        this.setState({ save_dialog_show_state: false });
      })
}

setSelectedProduct(selected_product_list, img_url){
  this.setState((prev) => {           
      const imageSlots = [...prev.imageSlots];
      imageSlots[this.state.currentImageSlotIndex] = { type: "product", data: img_url, product_no: selected_product_list[0].product_no, product_name: selected_product_list[0].product_name, product_price: selected_product_list[0].product_price, image_url: selected_product_list[0].image_url };
      return { imageSlots, selected_rp_product_list: selected_product_list };
  });
}

applydDesign(event_seq, img_url){
  this.setState((prev) => {           
      const imageSlots = [...prev.imageSlots];
      imageSlots[this.state.currentImageSlotIndex] = { type: "template", data: img_url, event_seq: event_seq, image_url: img_url };
      return { imageSlots, show_design_template_popup: false };
  });
}

setCaption = (nextCaption, callback) => {
  this.setState(prev => ({
    caption_history: [...prev.caption_history, prev.caption],
    caption: nextCaption,
    caption_future: []
  }), () => {
    if (callback) callback();
  });
};

// Undo
undoCaption = () => {
  this.setState(prev => {
    if (prev.caption_history.length === 0) return null;
    const prevCaption = prev.caption_history[prev.caption_history.length - 1];
    const caption_history = prev.caption_history.slice(0, -1);
    return {
      caption: prevCaption,
      caption_history,
      caption_future: [prev.caption, ...prev.caption_future]
    };
  });
};

// Redo
redoCaption = () => {
  this.setState(prev => {
    if (prev.caption_future.length === 0) return null;
    const nextCaption = prev.caption_future[0];
    const caption_future = prev.caption_future.slice(1);
    return {
      caption: nextCaption,
      caption_history: [...prev.caption_history, prev.caption],
      caption_future
    };
  });
};

handleDragEnd = (event) => {
  const { active, over } = event;
  if (!over) return;                    // 드랍 대상이 없으면 무시
  if (active.id === over.id) return;    // 같은 위치면 무시

  this.setState((prev) => {
    const { tags } = prev;
    const oldIndex = tags.indexOf(active.id);
    const newIndex = tags.indexOf(over.id);

    if (oldIndex === -1 || newIndex === -1) return null; // 방어

    return {
      tags: arraymMoveByDndKit(tags, oldIndex, newIndex),
    };
  });
};

  instagramFreePreriod() {
    http.get("/rest/shop/instagram/FreePreriod")
    .then(res => {
        if (res.data.is_finish != null) {
            this.setState({
                instagram_is_finish: res.data.is_finish,
            });

            if (res.data.is_finish == 1) {
              alert("이용 기간이 종료되었습니다.");
              window.location.href = "/shop/instagram/InstagramPostList";
            }
        }
    }).catch(error => {
        console.error(error);
    })
  }

  updateAccountsUseYn = (token_id, selected_account_list, use_yn) => {
    return http.post(
      "/rest/shop/instagram/updateAccountsUseYn",
      { token_id, selected_account_list, use_yn },
      {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
      }
    );
  };

updateSelectedAccountsUseYn = () => {
    const { token_id, selected_account_list } = this.state;

    if (!selected_account_list || selected_account_list.length === 0) {
      this.setState({
        warning_dialog_show_state: true,
        warning_dialog_content: "하나 이상의 계정을 선택 해 주세요."
      });
      return;
    }

    this.updateAccountsUseYn(token_id, selected_account_list, "Y")
      .then((res) => {
        const data = res && res.data ? res.data : {};
        if (String(data.code) === "200") {
          console.log("SUCCESS cnt:", data.cnt);
          this.loadInstagramAccountList();
          this.setState({
            show_account_connect_popup: false,
          });
        } else {
          console.log("FAIL:", data);
          this.setState({
            warning_dialog_show_state: true,
            warning_dialog_content: "계정 업데이트에 실패했습니다."
          });
        }
      })
      .catch((err) => {
        console.error("ERROR:", err);
        this.setState({
          warning_dialog_show_state: true,
          warning_dialog_content: "서버 요청 중 오류가 발생했습니다."
        });
      });
  };

  render() {
    return (
      <div
        id="page-wrapper"
        className="container eventFormPromotion"
        style={{ backgroundColor: "#fafaf" }}
      >
        <div className="InstagramCreatePost">
          <main className="main-content" style={{ display: "flex", gap: 20 }}>
            <div className="content-area" style={{ flex: 1 }}>
            
          <div className="create-post-flow" style={{ background: "#fff", borderRadius: 8, border: "1px solid #dbdbdb", overflow: "hidden", boxShadow: "0 2px 8px rgba(0,0,0,0.08)" }}>
            {this.renderStepTabs()}
            {this.renderStep1()}
            {this.renderStep2()}
            {this.renderStep3()}
          </div>
            </div>
            <div className="preview-area" style={{ flex: "0 0 350px" }}>{this.renderPreviewCard()}</div>
          </main>

          {/* 이미지 선택 모달 */}
          {this.state.imageModalOpen && (
            <div
              className="modal show"
              id="imageSourceModal"
              onClick={(e) => {
                if (e.target.classList.contains("modal")) this.closeImageModal();
              }}
              style={{
                position: "fixed",
                inset: 0,
                background: "rgba(0,0,0,0.5)",
                zIndex: 1000,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                // padding: 20,
                // paddingLeft: (document.querySelector(".pc_left_menu")?.offsetWidth || 0),
                // paddingTop: (document.querySelector(".pc_header")?.offsetHeight || 0)
              }}
            >
              <div
                className="modal-content"
                style={{
                  background: "#fff",
                  borderRadius: 12,
                  padding: 30,
                  // maxWidth: 500,
                  maxWidth: 540,
                  width: "100%",
                  maxHeight: "100%",
                  overflowY: "auto",
                }}
              >
                <h3 style={{ marginBottom: 20 }}>이미지를 어떻게 만들까요?</h3>
                <div
                  className="image-source-options"
                  style={{ display: "grid", gridTemplateColumns: "repeat(2,1fr)", gap: 15, margin: "20px 0" }}
                >
                  {[
                    { key: "upload", label: "직접 올리기", sub: "내 컴퓨터에서 선택", icon: "📁" },
                    { key: "product", label: "상품 사용", sub: "쇼핑몰 상품 선택", icon: "🛍️" },
                    { key: "ai", label: "AI 생성", sub: "AI로 이미지 만들기", icon: "🤖" },
                    { key: "template", label: "템플릿 사용", sub: "디자인 템플릿 적용", icon: "🎨" },
                  ].map((opt) => (
                    <div
                      key={opt.key}
                      className="source-option"
                      onClick={() => this.handleImageSource(opt.key)}
                      style={{
                        padding: 20,
                        border: "1px solid #dbdbdb",
                        borderRadius: 8,
                        cursor: "pointer",
                        textAlign: "center",
                      }}
                    >
                      <div className="source-option-icon" style={{ fontSize: 32, marginBottom: 10, color: "#00e2e6" }}>
                        {opt.icon}
                      </div>
                      <h4 style={{ marginBottom: 6 }}>{opt.label}</h4>
                      <p style={{ fontSize: 12, color: "#8e8e8e" }}>{opt.sub}</p>
                    </div>
                  ))}
                </div>
                <button className="btn btn-secondary" onClick={this.closeImageModal} style={{ width: "100%", marginTop: 20 }}>
                  취소
                </button>
              </div>
            </div>
          )}

          {/* 숨겨진 파일 입력 */}
          <input type="file" ref={this.fileInputRef} accept="image/*" style={{ display: "none" }} />
        </div>

       {
          /* 연결한 계정을 선택하는 팝업 */
          this.state.show_account_connect_popup && (
            <PopupFrameV2
              className={"account-connect-popup"}
              maxWidth={"950px"}
              onClose={() => this.setState({ show_account_connect_popup: false })}
            >
              <div className="instagram_account_page" style={{ paddingBottom: 52}}>
                <h5 style={{ marginBottom: 20 }}>연결할 인스타그램 계정을 선택해주세요</h5>
                {(this.state.add_account_list || []).map((account) => (
                  // <div className="facebook-group">
                    <div className="instagram-accounts" key={account.token_id}>
                      {(Array.isArray(account.instagram_account_list)
                        ? account.instagram_account_list
                        : []
                      )
                        // 혹시 완전 빈 데이터(키값이 null) 들어오는 거 걸러내기
                        .filter((instagram) => instagram && instagram.instagram_access_token_seq)
                        .map((instagram) => (
                          <div
                            className="account-card"
                            key={instagram.instagram_access_token_seq}
                            onClick={(e) => {
                              if (e.target.closest('input[type="checkbox"], label')) return;
                              console.log("onClick");
                              let selected_account_list = [...this.state.selected_account_list];
                              const v = String(instagram.instagram_access_token_seq);

                              if (selected_account_list.includes(v)) {
                                // 이미 있으면 제거
                                console.log("onClick 이미 있으면 제거");
                                selected_account_list = selected_account_list.filter(seq => seq !== v);
                              } else {
                                // 없으면 추가
                                console.log("onClick 없으면 추가");
                                selected_account_list.push(v);
                              }

                              this.setState({ selected_account_list });
                              console.log("onClick 1");
                            }}
                            style={{
                              display: "flex",
                              gap: "18px",
                              cursor: "pointer",
                              userSelect: "none",
                              WebkitUserSelect: "none",
                              msUserSelect: "none",
                              WebkitUserDrag: "none",
                              WebkitTouchCallout: "none",
                            }}
                          >
                            <CheckBox
                              id={String(instagram.instagram_access_token_seq)}
                              value={String(instagram.instagram_access_token_seq)}
                              checked={this.state.selected_account_list.includes(
                                String(instagram.instagram_access_token_seq)
                              )}
                              onChangeCheck={(e) => {
                                console.log("onChangeCheck");
                                // e.preventDefault();

                                let selected_account_list = [...this.state.selected_account_list];
                                const v = String(instagram.instagram_access_token_seq);

                                if (selected_account_list.includes(v)) {
                                  // 이미 있으면 제거
                                  console.log("onChangeCheck 이미 있으면 제거");
                                  selected_account_list = selected_account_list.filter(seq => seq !== v);
                                } else {
                                  // 없으면 추가
                                  console.log("onChangeCheck 없으면 추가");
                                  selected_account_list.push(v);
                                }

                                this.setState({ selected_account_list });

                                console.log("onChangeCheck 1");
                              }}
                            />

                            <div className="account-wrapper">
                              <div className="account-left">
                                <div className="account-avatar">
                                  {!!instagram.profile_picture_url && (
                                    <img src={instagram.profile_picture_url} alt="" />
                                  )}
                                </div>
                                <div className="account-info">
                                  <div className="account-username">
                                    {instagram.username || "(username 없음)"}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                    </div>
                  // </div>
                ))}
              </div>

              <div
                style={{
                  display: "flex",
                  width: "calc(100% - 24px)",
                  justifyContent: "flex-end",
                  position: "absolute",
                  bottom: "0px",
                  paddingBottom: "12px",
                  // backgroundColor: "#fff",
                }}
              >
                <button className="btn btn-primary"
                  onClick={() => {
                    this.updateSelectedAccountsUseYn();
                  }}
                >
                  연결하기
                </button>
              </div>
            </PopupFrameV2>
          )
        } 

        {/* 확인 취소 다이얼로그 */
          (this.state.confirm_dialog_show_state === true)
          ? <ConfirmDialogV2
              content={this.state.confirm_dialog_content}
              button_list={this.state.confirm_dialog_button_list}
              popup_close={() => {
                  this.setState({confirm_dialog_show_state: false});
              }}
          />
          : ''
        }
        {/** 로딩 다이얼로그 */
          (this.state.save_dialog_show_state === true)
          ? <SaveDialogV2
              content={this.state.save_dialog_content}
              button_list={this.state.save_dialog_button_list}
          />
          : ''
        }
        {/* 안내 문구 전달용 기본 다이얼로그 */
          (this.state.basic_dialog_show_state === true)
            ? <BasicDialogV2
              content={this.state.basic_dialog_content}
              content2={this.state.basic_dialog_content2}
              button_list={this.state.basic_dialog_button_list}
            />
            : ''
        }
        {/* 경고 다이얼로그 */
          this.state.warning_dialog_show_state === true &&
          <WarningDialog
              content={this.state.warning_dialog_content}
              button_list={this.state.warning_dialog_button_list}
          />
        }

        {/** 로보 이미지 팝업 */
          this.state.show_robo_img_popup
          ?
          // <RoboImgSettingPopup
          //     onClose={e => {this.setState({show_robo_img_popup:false})}}
          //     sendRoboImg={(img, stability_call_seq) => {
          //         this.applyAIImg(img, stability_call_seq);
          //         this.setState({show_robo_img_popup:false});
          //     }}
          // />
          <RoboImageStudioTabs
            className=""
            onClose={e => {this.setState({show_robo_img_popup:false})}}
            sendRoboImg={(img, stability_call_seq) => {
              const config = {
                headers: {
                    'Content-Type': 'application/json',
                }
              }

              const body = {
                image_url: img,
                ratio: this.state.currentRatio ? this.state.currentRatio : "1/1",
              }

              http.post("/rest/shop/instagram/resizeUrlImg", body, config)
              .then(res => {
                  const url = res.data.org_img_path;
                  this.applyAIImg(url, stability_call_seq);
                  this.setState({show_robo_img_popup:false});
                }).catch(error => {
                  console.log (error);
                  this.setState({show_robo_img_popup:false});
                })
            }}
            defaultTab="GENERATE"       // 또는 "INPAINT"
            remountOnTabSwitch={false}   // 탭 전환 시 새로 마운트
            // isSquareOnly={true}
            ratio={this.state.currentRatio || "1/1"}
            service_type="01014"
          />
          :""
        }
        {/** 상품 추가 팝업 */
          this.state.show_add_product_popup
          ? <SearchProductPopup
              title = {"상품 추가"}
              select_type = {"radio"}
              selected_product_list = {this.state.selected_rp_product_list || []}
              image_type_cd = {this.state.image_type_cd || ""}
              onClose = {() => {this.setState({show_add_product_popup:false})}}
              onSubmit = {this.onClickAddProductbtn.bind(this)}
              submit_btn_name = {"선택 상품 추가"}
          />
         : ""
        }
        { /** 디자인 템플릿 편집 팝업 */
          this.state.show_design_template_popup
          ? <InstagramTemplateEditor
              onClose = {() => {this.setState({show_design_template_popup:false})}}
              onSubmit = {this.applydDesign.bind(this)}
              event_seq = {this.state.selected_event_seq}
              ratio = {this.state.currentRatio ? this.state.currentRatio.replace("/", ":") : "1:1"}
          />
          : ""
        }
        {
          this.state.isSizeModalOpen
          ? <ModalSizeSelect
              isOpen={this.state.isSizeModalOpen}
              onSelect={(ratio) => {
                console.log("선택된 비율:", ratio);

                let text = '1:1 모드';
                if(ratio === '4/5') text = '4:5 모드';
                else if(ratio === '16/9') text = '16:9 모드';

                this.setState({ isSizeModalOpen: false, currentRatio: ratio, currentRatioText: text, imageModalOpen: true });

                // Close Modal
                document.getElementById('modalSizeSelect').classList.remove('open');
              }}
            />
          : ""
        }
      </div>
    );
  }
}